const messages = {
  ja: {
    translations: {
      gridHotelFeedback: {
        dashboard: 'ダッシュボード',
        service_grid: 'アンケートと満足度のグリッド',
        service_grid_single: 'アンケートと満足度のグリッド',
        listed_grids: 'アンケートと満足度のグリッドを以下に示します',
        create_service_grid: 'アンケートと満足度のグリッドを作成',
        title: 'タイトル',
        status: 'ステータス',
        grid_deleted: 'グリッドを削除しました！',
        grid_deleted_message: 'アンケートと満足度のグリッドは正常に削除されました。',
        error: 'エラー',
        error_delete_message: 'アンケートと満足度のグリッドの削除中にエラーが発生しました。',
        service_grid_name: 'タイトル',
        service_grid_name_placeholder: '例：満足度アンケート',
        fill_information_create:
          '以下の情報を入力し、「作成」ボタンをクリックして変更を保存してください',
        missing_fields: '必須フィールド',
        missing_fields_message: '「タイトル」フィールドと「項目リスト」は必須です！',
        grid_created: 'グリッドを登録しました',
        grid_created_message: '登録が正常に完了しました！',
        error_create_message: 'グリッドの登録中にエラーが発生しました！',
        service_list: '項目リスト',
        service_placeholder: '項目を追加（例：客室の品質）',

        // CHAVES ADICIONADAS/MIGRADAS PARA A PÁGINA DE EDIÇÃO (UPDATE)
        edit_service_grid: 'アンケートと満足度のグリッドを編集',
        save_changes_edit: '以下の情報を入力し、「保存」ボタンをクリックして変更を確定してください',
        grid_updated: 'グリッドが変更されました',
        grid_updated_message: '編集が正常に完了しました！',
        error_update_message: 'グリッドの変更中にエラーが発生しました！',

        general: {
          actions: 'アクション',
          edit: '編集',
          delete: '削除',
          active: 'アクティブ',
          inactive: '非アクティブ',
          select: '選択',
          back: '戻る',
        },
        buttons: {
          create: '作成',
          back: '戻る',
          save: '保存',
        },
      },
      // 店舗の言語管理ページの翻訳
      translate_stores: {
        page_title: '店舗の言語と関係の管理',
        page_subtitle: 'システム内の各店舗の翻訳言語と関係を管理します。',
        page_title_relationships: '店舗間の関係の管理',
        page_subtitle_relationships: 'システム内の店舗間の関係を管理します。',
        tab_translations: '言語を管理',
        tab_relations: '店舗間の関係',
        breadcrumb: {
          dashboard: 'ダッシュボード',
          translate_stores: '言語を管理',
        },
        filters: {
          status: 'ステータス',
          type: 'タイプ',
          active: 'アクティブ',
          inactive: '非アクティブ',
          both: '両方',
          all_types: 'すべて',
          status_placeholder: '店舗のステータス',
          type_placeholder: '店舗のタイプ',
          filter_button: 'フィルタ',
        },
        status_options: {
          active: 'アクティブ',
          inactive: '非アクティブ',
          both: '両方',
          all_types: 'すべて',
        },
        languages: {
          portuguese: 'ポルトガル語',
          spanish: 'スペイン語',
          english: '英語',
          french: 'フランス語',
          german: 'ドイツ語',
          italian: 'イタリア語',
          japanese: '日本語',
          korean: '韓国語',
          chinese: '中国語',
        },
        table: {
          headers: {
            type: 'タイプ',
            id: 'ID',
            name: '名前',
            subdomain: 'サブドメイン',
            status: 'ステータス',
            created: '作成日',
            cnpj: 'CNPJ',
            actions: 'アクション',
          },
          type: 'タイプ',
          id: 'ID',
          name: '名前',
          subdomain: 'サブドメイン',
          status: {
            active: 'アクティブ',
            inactive: '非アクティブ',
          },
          created: '作成日',
          cnpj: 'CNPJ',
          actions: 'アクション',
        },
        actions: {
          manage_languages: '言語を管理',
          edit: '編集',
        },
        messages: {
          success: {
            title: '成功',
            save: '言語が正常に保存されました！',
          },
          error: {
            title: 'エラー',
            load_data: '店舗データの読み込み中にエラーが発生しました！',
            save_languages: '言語の保存中にエラーが発生しました！',
          },
        },
        modal: {
          title: '言語を管理',
          description: 'この店舗で翻訳に利用できる言語を選択してください：',
          alert: {
            title: '注意',
            message: 'この店舗で翻訳に使用する言語を有効または無効にします。',
          },
          buttons: {
            cancel: 'キャンセル',
            save: '保存',
          },
        },
        relations: {
          no_relations: '関連付けが見つかりませんでした',
          create_title: '関連付けを作成',
          edit_title: '関連付けを編集',
          parent_label: '親店舗',
          child_label: '子店舗',
          parent_missing: '親店舗を選択してください',
          child_missing: '子店舗を選択してください',
          same_store_error: '親店舗は子店舗と同じにすることはできません',
          created_success: '関連付けが正常に作成されました',
          updated_success: '関連付けが正常に更新されました',
          deleted_success: '関連付けが正常に削除されました',
          error_create: '関連付けの作成中にエラーが発生しました',
          error_update: '関連付けの更新中にエラーが発生しました',
          error_delete: '関連付けの削除中にエラーが発生しました',
          store_not_found: '店舗が見つかりませんでした',
          all_option: 'すべて',
          cancel: 'キャンセル',
          save: '保存',
          delete_confirm: 'はい、削除',
          create_button: '関連付けを作成',
          save_changes: '変更を保存',
          create_description:
            'どの店舗が親店舗になり、どの店舗が子店舗になるかを定義します。親店舗は複数の子店舗を持つことができ、その設定を管理できます。',
          edit_description: '選択した店舗間の関連付けを編集します。変更はすぐに適用されます。',
          summary_title: '関連付けの概要：',
          tips_title: '重要なヒント：',
          tip_parent_multiple: '親店舗は複数の子店舗を持つことができます',
          tip_child_single: '子店舗は複数の親を持つことができます',
          tip_all_available: 'すべての店舗（アクティブおよび非アクティブ）が選択可能です',
          click_new: '「新規関連付け」をクリックして開始します',
          message_delete:
            'この関連付けを削除してもよろしいですか？この操作は元に戻すことはできません。',
        },
      },
      hospitality_review: {
        page_title: 'ホテルの評価',
        page_subtitle: 'ホテルの宿泊客からの評価とレーティングを管理および監視します。',
        breadcrumb: {
          dashboard: 'ダッシュボード',
          hospitality: 'ホスピタリティ',
          reviews: '評価',
        },
        statistics: {
          total_reviews: '合計評価数',
          average_rating: '全体平均',
        },
        filters: {
          filter_by_type: 'タイプでフィルタ',
          filter_by_rating: '評価でフィルタ',
        },
        type_options: {
          all_types: 'すべて',
          general: '一般',
          room: '客室',
          food: '食事',
          service: 'サービス',
          cleanliness: '清潔さ',
          activities: 'アクティビティ',
        },
        rating_options: {
          all_ratings: 'すべての評価',
          five_stars: '5つ星',
          four_stars: '4つ星',
          three_stars: '3つ星',
          two_stars: '2つ星',
          one_star: '1つ星',
        },
        table: {
          headers: {
            rating: '評価',
            type: 'タイプ',
            comment: 'コメント',
            date: '日付',
            actions: 'アクション',
          },
          actions: {
            view_full_review: '完全な評価を表示',
          },
          status: {
            approved: '承認済み',
            pending: '保留中',
          },
        },
        modal: {
          review_title: '評価者：',
          fields: {
            rating: '評価',
            type: 'タイプ',
            status: 'ステータス',
            date: '日付',
            comment: 'コメント',
            email: 'メール',
          },
          guest_anonymous: '匿名',
        },
        messages: {
          success: {
            review_deleted: '評価が削除されました',
            delete_success: '削除が正常に実行されました！',
            status_updated: 'ステータスが更新されました',
            approved_success: '評価が正常に承認されました！',
            suspended_success: '評価が正常に停止されました！',
          },
          error: {
            title: 'エラー',
            load_reviews: 'ホテルの評価の読み込み中にエラーが発生しました！',
            invalid_id: '削除するIDが無効です！',
            delete_error: '評価の削除中にエラーが発生しました！',
            status_error: '評価のステータス変更中にエラーが発生しました！',
          },
          confirm: {
            delete_title: '削除の確認',
            delete_text: 'この評価を削除してもよろしいですか？',
            delete_confirm: 'はい、削除',
            delete_cancel: 'キャンセル',
          },
        },
      },
      hospitality_info: {
        page_title: 'ホテルの情報',
        page_subtitle: 'ホテルの連絡先、時間、サービスを管理します。',
        tabs: {
          contact: '連絡先',
          hours: '営業時間と情報',
          services: 'サービス',
          ramal: '内線',
          about: 'ホテルについて',
        },
        statusOptions: {
          all: 'すべて',
          active: '有効',
          inactive: '無効',
          expired: '期限切れ',
        },
        contact: {
          phone_label: '電話',
          phone_placeholder: '(11) 99999-9999',
          whatsapp_label: 'WhatsApp',
          whatsapp_placeholder: '(11) 99999-9999',
          email_label: 'Eメール',
          email_placeholder: 'hotel@email.com',
        },
        hours: {
          title: 'ホテル営業時間と情報',
          add_button: '営業時間/情報を追加',
          remove_button: '削除',
          hour_number: '項目',
          title_label: 'タイトル',
          title_placeholder: '例：受付、プール、レストラン',
          description_label: '営業時間と情報',
          description_placeholder: '営業時間と追加情報を説明（例：08:00 - 22:00、週末は休業）',
        },
        services: {
          title: 'ホテルサービス',
          add_button: 'サービスを追加',
          remove_button: '削除',
          service_number: 'サービス',
          service_title_label: 'サービス名',
          service_title_placeholder: '例：ルームサービス',
          service_description_label: '説明',
          service_description_placeholder: 'サービスを説明',
        },
        ramal: {
          title: 'ホテル内線',
          add_button: '内線を追加',
          remove_button: '削除',
          ramal_number: '内線',
          ramal_title_label: '内線タイトル',
          ramal_title_placeholder: '例: 504',
          ramal_description_label: '説明',
          ramal_description_placeholder: '内線を説明',
        },
        about: {
          description_label: 'ホテルについて',
          description_placeholder:
            'ホテルに関する一般情報、歴史、独自の特徴や特別な特性を説明してください',
        },
        actions: {
          save_button: '保存',
        },
        messages: {
          error_title: 'エラー',
          error_text: 'ホテルの情報を保存できませんでした。',
          success_title: '保存しました！',
          success_text: 'ホテルの情報が正常に保存されました。',
          required_phone: '電話番号は必須です。',
          required_email: 'Eメールは必須です。',
          required_hours: 'すべての項目にはタイトルと説明が必要です。',
          required_service: 'すべてのサービスにはタイトルと説明が必要です。',
          required_ramal: 'すべての内線にはタイトルと説明が必要です。',
        },
      },
      hospitality_schedules: {
        page_title: 'ホテルのプログラム',
        page_subtitle: 'ホテルのイベントとプログラムを管理します。',
        new_button: '新しいプログラム',
        edit_button: 'プログラムを編集',
        delete_button: 'プログラムを削除',
        delete_confirm:
          'このプログラムを削除してもよろしいですか？この操作は元に戻すことはできません。',
        table: {
          title: 'タイトル',
          type: 'タイプ',
          location: '場所',
          time: '時間',
          recurrence: '繰り返し',
          period: '期間',
          status: 'ステータス',
          actions: 'アクション',
          active: 'アクティブ',
          inactive: '非アクティブ',
          single_event: '単一イベント',
          all_types: 'すべて',
          all_status: 'すべてのステータス',
          age_group: '年齢層',
        },
        filters: {
          type: 'タイプ',
          type_placeholder: 'タイプを選択',
          status: 'ステータス',
          status_placeholder: 'ステータスを選択',
          date_init: '開始日',
          date_init_placeholder: '開始日',
          date_end: '終了日',
          date_end_placeholder: '終了日',
          search: '検索',
          clear: 'フィルタをクリア',
        },
        messages: {
          load_error: 'プログラムの読み込み中にエラーが発生しました！',
          delete_success: 'プログラムが正常に削除されました！',
          delete_error: 'プログラムの削除中にエラーが発生しました！',
        },
        types: {
          activity: 'エンターテイメント',
          food: 'ガストロノミー',
          event: 'イベント',
          tour: 'ツアー',
        },
        age_groups: {
          all: 'すべての人',
          children: '子供',
          teens: 'ティーンエイジャー',
          adults: '大人',
          seniors: '高齢者',
          family: '家族',
        },
        singleEvent: '単一イベント',
      },
      hospitality_schedule_edit: {
        page_title: 'プログラムを編集',
        page_subtitle: '編集中： {{title}}',
        not_found: {
          title: 'プログラムが見つかりませんでした',
          description: '編集しようとしているプログラムは見つかりませんでした。',
          back_button: 'リストに戻る',
        },
        form: {
          type_label: 'タイプ',
          type_placeholder: 'タイプを選択',
          type_sports: 'スポーツ',
          type_wellness: 'ウェルネス',
          type_other: 'その他',
          title_label: 'タイトル',
          title_placeholder: 'プログラムのタイトルを入力',
          description_label: '説明',
          description_placeholder: 'プログラムを説明',
          location_label: '場所',
          location_placeholder: 'プログラムの場所',
          time_label: '時間',
          time_placeholder: '例: 14:00 - 16:00 または 14:00',
          time_smalltext: 'フォーマット: "HH:MM - HH:MM" または "HH:MM"',
          recurrence_config: '繰り返し設定',
          single_event_radio: '単一イベント - 特定の日に発生するイベント',
          recurring_event_radio: '繰り返しイベント - 毎週特定の曜日に繰り返されるイベント',
          day_within_date_range_radio: '日付範囲内のイベント - 特定の日付範囲内で発生するイベント',
          days_of_week_label: '曜日',
          selected_days: '選択済み: {{days}}',
          date_init_label: '開始日',
          date_init_placeholder: '開始日',
          date_end_label: '終了日',
          date_end_placeholder: '終了日 (オプション)',
          status_label: 'ステータス',
          back_button: '戻る',
          save_button: '変更を保存',
        },
      },
      hospitality_schedule_create: {
        page_title: '新しいプログラム',
        page_subtitle: 'ホテル用に新しいプログラムを作成',
        success: {
          title: '成功！',
          text: 'プログラムが正常に作成されました！',
        },
        error: {
          title: 'エラー',
          text: 'プログラムの作成中にエラーが発生しました！',
        },
        form: {
          title_label: 'タイトル *',
          title_placeholder: 'プログラムのタイトルを入力',
          title_required: 'タイトルは必須です',
          type_label: 'タイプ *',
          type_placeholder: 'タイプを選択',
          type_sports: 'スポーツ',
          type_wellness: 'ウェルネス',
          type_other: 'その他',
          description_label: '説明 *',
          description_placeholder: 'プログラムを説明',
          description_required: '説明は必須です',
          location_label: '場所 *',
          location_placeholder: 'プログラムの場所',
          location_required: '場所は必須です',
          time_label: '時間 *',
          time_placeholder: '例: 14:00 - 16:00 または 14:00',
          time_smalltext: 'フォーマット: "HH:MM - HH:MM" または "HH:MM"',
          time_required: '時間は必須です',
          recurrence_config: '繰り返し設定',
          single_event_radio: '単一イベント - 特定の日に発生するイベント',
          recurring_event_radio: '繰り返しイベント - 毎週特定の曜日に繰り返されるイベント',
          day_within_date_range_radio: '日付範囲内のイベント - 特定の日付範囲内で発生するイベント',
          days_of_week_label: '曜日',
          selected_days: '選択済み: {{days}}',
          date_init_label: '開始日',
          date_init_placeholder: '開始日',
          date_end_label: '終了日',
          date_end_placeholder: '終了日 (オプション)',
          status_label: 'ステータス',
          back_button: '戻る',
          save_button: '保存',
        },
      },
      hospitality_banner: {
        page_title: 'ホテルのバナー',
        page_subtitle: 'ホテルのバナーを管理します。表示期間、順序、ステータスを制御します。',
        breadcrumb: {
          hospitality: 'ホスピタリティ',
          publicity: '広告',
        },
        new_button: '新しい広告',
        table: {
          title: 'タイトル',
          image: '画像',
          order: '順序',
          period: '期間',
          created_date: '作成日',
          status: 'ステータス',
          actions: 'アクション',
        },
        actions: {
          edit: '広告を編集',
          view: '詳細を表示',
          delete: '広告を削除',
        },
        modal: {
          title: '広告 #{{id}}',
          order: '順序',
          status: 'ステータス',
          active: 'アクティブ',
          inactive: '非アクティブ',
          period: '期間',
          created: '作成日',
          updated: '最終更新日',
          image: '画像',
          no_image: '画像なし',
        },
        delete: {
          confirm_title: '削除の確認',
          confirm_text: 'この広告を削除してもよろしいですか？',
          confirm_button: 'はい、削除',
          cancel_button: 'キャンセル',
          success_title: '広告が削除されました',
          success_text: '削除が正常に実行されました！',
        },
        status: {
          success_title: 'ステータスが更新されました',
          success_text: '広告は正常に{{action}}されました！',
          activated: '有効化',
          deactivated: '無効化',
        },
        error: {
          title: 'エラー',
          load_data: '広告データの読み込み中にエラーが発生しました！',
          invalid_id: '削除するIDが無効です！',
          delete: '広告の削除中にエラーが発生しました！',
          status_change: '広告のステータス変更中にエラーが発生しました！',
        },
      },
      hospitality_banner_create: {
        page_title: '新しいホテルのバナーを作成',
        page_subtitle: '以下の情報を入力して、新しいバナーを作成してください。',
        breadcrumb: {
          hospitality: 'ホスピタリティ',
          publicity: '広告',
          create: '広告を作成',
        },
        form: {
          title_label: 'バナーのタイトル *',
          title_placeholder: '例: ハイキング...',
          order_label: '表示順序 *',
          order_placeholder: '例: 1, 2, 3...',
          order_smalltext: '広告の優先順位（小さい番号が最初に表示されます）',
          status_label: '広告を有効化',
          status_smalltext: 'チェックして広告を有効化します',
          start_date_label: '開始日 *',
          start_time_label: '開始時間 *',
          end_date_label: '終了日 *',
          end_time_label: '終了時間 *',
          image_label: '広告の画像',
          image_select: '画像を選択',
          image_formats: '利用可能なフォーマット: JPG、PNG、GIF',
          image_optional: 'オプション - 提供されない場合はデフォルトの画像が使用されます',
          image_preview: '画像のプレビュー',
          image_remove: '画像を削除',
        },
        preview: {
          period_title: '広告の期間：',
          start: '開始',
          end: '終了',
        },
        validation: {
          title: '検証エラー',
          order_positive: '順序はゼロより大きい数値である必要があります！',
          start_date_required: '開始日は必須です！',
          end_date_required: '終了日は必須です！',
          dates_required: '日付と時間は必須です！',
          start_before_end: '開始日は終了日より前である必要があります！',
        },
        success: {
          title: '広告が作成されました',
          text: '広告が正常に作成されました！',
        },
        error: {
          title: 'エラー',
          text: '広告の作成中にエラーが発生しました！',
        },
      },
      hospitality_banner_update: {
        page_title: 'ホテルの広告を編集',
        page_subtitle: '広告 #{{id}} を編集',
        breadcrumb: {
          edit: '広告を編集',
        },
        current_image: '現在の画像',
        save_button: '変更を保存',
        not_found: {
          title: '広告が見つかりませんでした',
          text: '編集しようとしている広告は見つかりませんでした。',
          back_button: 'リストに戻る',
        },
        no_changes: {
          title: '変更なし',
          text: 'フィールドが変更されていません！',
        },
        success: {
          title: '広告が更新されました',
          text: '広告が正常に更新されました！',
        },
        error: {
          title: 'エラー',
          text: '広告の更新中にエラーが発生しました',
          load_data: '広告データの読み込み中にエラーが発生しました！',
          update: '広告の更新中にエラーが発生しました！',
        },
      },
      hospitality_publicity: {
        page_title: 'ホテルのハイライトバナー',
        page_subtitle:
          'ホテルのハイライトバナーを管理します。表示期間、順序、ステータスを制御します。',
        breadcrumb: {
          hospitality: 'ホスピタリティ',
          publicity: '広告',
        },
        new_button: '新しいバナー',
        table: {
          image: '画像',
          order: '順序',
          period: '期間',
          created_date: '作成日',
          status: 'ステータス',
          actions: 'アクション',
        },
        actions: {
          edit: '広告を編集',
          view: '詳細を表示',
          delete: '広告を削除',
        },
        modal: {
          title: '広告 #{{id}}',
          order: '順序',
          status: 'ステータス',
          active: 'アクティブ',
          inactive: '非アクティブ',
          period: '期間',
          created: '作成日',
          updated: '最終更新日',
          image: '画像',
          no_image: '画像なし',
        },
        delete: {
          confirm_title: '削除の確認',
          confirm_text: 'この広告を削除してもよろしいですか？',
          confirm_button: 'はい、削除',
          cancel_button: 'キャンセル',
          success_title: '広告が削除されました',
          success_text: '削除が正常に実行されました！',
        },
        status: {
          success_title: 'ステータスが更新されました',
          success_text: '広告は正常に{{action}}されました！',
          activated: '有効化',
          deactivated: '無効化',
        },
        error: {
          title: 'エラー',
          load_data: '広告データの読み込み中にエラーが発生しました！',
          invalid_id: '削除するIDが無効です！',
          delete: '広告の削除中にエラーが発生しました！',
          status_change: '広告のステータス変更中にエラーが発生しました！',
        },
      },
      hospitality_publicity_create: {
        page_title: 'ホテルの広告を作成',
        page_title_edit: 'ホテルの広告を編集',
        page_subtitle: '以下の情報を入力して、新しい広告を作成してください。',
        breadcrumb: {
          hospitality: 'ホスピタリティ',
          publicity: '広告',
          create: '広告を作成',
        },
        form: {
          order_label: '表示順序 *',
          order_placeholder: '例: 1, 2, 3...',
          order_smalltext: '広告の優先順位（小さい番号が最初に表示されます）',
          status_label: '広告を有効化',
          status_smalltext: 'チェックして広告を有効化します',
          start_date_label: '開始日 *',
          start_time_label: '開始時間 *',
          end_date_label: '終了日 *',
          end_time_label: '終了時間 *',
          image_label: '広告の画像',
          image_select: '画像を選択',
          image_formats:
            '利用可能なフォーマット: JPG、PNG、GIF | 寸法: ~200x112px | 最大サイズ: 2MB',
          image_optional: 'オプション - 提供されない場合はデフォルトの画像が使用されます',
          image_preview: '画像のプレビュー',
          image_remove: '画像を削除',
          external_link_checkbox: '外部リンクを含める',
          external_link_label: '外部リンク',
          external_link_placeholder: 'https://example.com',
          description_label: 'バナーの説明',
          description_smalltext: '* 最大 {qtd} 文字',
          title_label: 'バナーのタイトル',
          title_placeholder: '例: ハイキング...',
          title_smalltext: '* 最大 {qtd} 文字',
        },
        preview: {
          period_title: '広告の期間：',
          start: '開始',
          end: '終了',
        },
        validation: {
          title: '検証エラー',
          order_positive: '順序はゼロより大きい数値である必要があります！',
          start_date_required: '開始日は必須です！',
          end_date_required: '終了日は必須です！',
          dates_required: '日付と時間は必須です！',
          start_before_end: '開始日は終了日より前である必要があります！',
          external_link_required: 'オプションが選択されている場合、外部リンクは必須です！',
          image_size_error: '画像のサイズは最大2MBである必要があります！',
          image_dimensions_error:
            '画像の寸法は約200x112ピクセルである必要があります！現在：{{current}}',
          image_invalid: '無効な画像ファイルです！有効な画像を選択してください。',
        },
        success: {
          title: '広告が作成されました',
          text: '広告が正常に作成されました！',
        },
        error: {
          title: 'エラー',
          text: '広告の作成中にエラーが発生しました！',
          update: '広告の更新中にエラーが発生しました！',
        },
        not_found: {
          title: '広告が見つかりませんでした',
          text: '編集しようとしている広告は見つかりませんでした。',
          back_button: 'リストに戻る',
        },
        no_changes: {
          title: '変更なし',
          text: 'フィールドが変更されていません！',
        },
        current_image: '現在の画像',
      },
      // ファイルに追加
      service_list: {
        filters: {
          categories: 'カテゴリー',
          category_placeholder: 'カテゴリー',
          filter_button: 'フィルタ',
          all_categories: 'すべて',
        },
        table: {
          schedule: 'スケジュール',
          extension: '内線',
        },
        actions: {
          delete_service: 'サービスを削除',
        },
      },
      // ファイルに追加
      service_create: {
        page_title: 'サービスを登録',
        breadcrumb: {
          services: 'サービス',
          create: '作成',
        },
        form: {
          classification_placeholder: '分類を選択',
          name_label: '名前',
          name_placeholder: 'サービスの名前',
          description_label: '説明',
          description_placeholder: 'サービスの説明',
          schedule_label: '営業時間',
          schedule_placeholder: '例: 24時間、08:00-18:00、オンデマンド',
          schedule_smalltext: '最大 50 文字',
          extension_label: '内線',
          extension_placeholder: '例: 1001、2050',
          extension_smalltext: '最大 10 文字',
          code_label: 'コード',
          code_placeholder: 'サービスのコード',
          order_label: '順序',
          order_placeholder: '表示順序',
          status_label: 'ステータス',
          status_active: 'アクティブ',
          status_inactive: '非アクティブ',
          external_link_label: '外部リンク',
          external_link_placeholder: 'https://example.com',
          priority_label: '優先度',
          priority_low: '低',
          priority_normal: '通常',
          priority_high: '高',
          priority_critical: '緊急',
        },
        icons: {
          title: 'アイコン',
          category_label: 'アイコンのカテゴリ',
          all_categories: 'すべて',
          selected_icon: '選択されたアイコン',
        },
        validation: {
          missing_fields_title: '不足しているフィールド',
          missing_fields_text:
            'すべての必須フィールド（名前、分類、アイコン）に入力したか確認してください！',
        },
        success: {
          title: 'サービスが登録されました',
          text: '登録が正常に実行されました！',
        },
        error: {
          title: 'エラー',
          text: 'サービスの登録中にエラーが発生しました！',
          icons_load: 'タイプの検索中にエラーが発生しました',
        },
      }, // ファイルに追加
      service_update: {
        page_title: 'サービスを編集',
        page_title_full: 'サービスを更新',
        breadcrumb: {
          edit: '編集',
        },
        error: {
          title: 'エラー',
          load_data: 'サービスデータの読み込み中にエラーが発生しました！',
          text: 'サービスの更新中にエラーが発生しました！',
        },
        success: {
          title: 'サービスが更新されました',
          text: '編集が正常に実行されました！',
        },
      },
      // ファイルに追加
      service_category_create: {
        validation: {
          missing_fields_title: '不足しているフィールド',
          missing_fields_text: 'すべてのフィールドに入力したか確認してください！',
        },
        success: {
          title: '分類が登録されました',
          text: '登録が正常に実行されました！',
        },
        error: {
          title: 'エラー',
          text: '分類の登録中にエラーが発生しました！',
          create: '分類の登録中にエラーが発生しました！',
        },
      },

      // ファイルに追加
      service_category_list: {
        page_title: 'コンテンツのカテゴリ',
        page_subtitle: 'コンテンツのカテゴリとそれに対応するアクションをここに示します。',
        breadcrumb: {
          categories: 'カテゴリー',
        },
        add_button: '追加',
        table: {
          name: '名前',
          status: 'ステータス',
          actions: 'アクション',
        },
        actions: {
          edit_category: 'カテゴリを編集',
          delete_category: 'カテゴリを削除',
        },
        delete: {
          error_title: 'エラー',
          error_text: 'カテゴリの削除中にエラーが発生しました！',
          success_title: 'カテゴリが削除されました',
          success_text: '削除が正常に実行されました！',
          confirm_title: 'よろしいですか？',
          confirm_text: 'カテゴリは削除され、元に戻すことはできません！',
          cancel_button: '閉じる！',
          confirm_button: '削除！',
        },
      },
      service_category_update: {
        error: {
          title: 'エラー',
          load_data: '分類データの読み込み中にエラーが発生しました！',
          text: '分類の更新中にエラーが発生しました！',
          update: '分類の更新中にエラーが発生しました！',
        },
        success: {
          title: '分類が更新されました',
          text: '編集が正常に実行されました！',
        },
      },
      hotelRoom: {
        status: {
          available: '利用可能',
          reserved: '予約済み',
          maintenance: 'メンテナンス中',
          occupied: '使用中',
          being_cleaning: '清掃中',
        },
        type: {
          single: 'シングルルーム',
          double: 'ダブルルーム',
          twin: 'ツインルーム',
          queen: 'クイーンルーム',
          king: 'キングルーム',
          suite: 'スイートルーム',
          junior_suite: 'ジュニアスイート',
          master_suite: 'マスタースイート',
          presidential: 'プレジデンシャルスイート',
          family: 'ファミリールーム',
          accessible: 'バリアフリールーム',
        },
      },
      hospitality_room_reservation: {
        create: {
          wizard_step_customer: '顧客',
          wizard_step_reservation: '予約',
          wizard_step_confirmation: '確認',
          wizard_step1: 'ステップ 1',
          wizard_step2: 'ステップ 2',
          wizard_step3: 'ステップ 3',
          wizard_customer_title: '顧客を選択または登録',
          wizard_customer_search_placeholder: '名前、メール、または電話で検索...',
          wizard_customer_search_button: '既存の顧客を検索',
          wizard_customer_new_button: '新規顧客を登録',
          wizard_customer_none_found: '顧客が見つかりませんでした',
          wizard_customer_showing_first:
            '最初の 20 件の結果を表示しています。検索を絞り込んで他の顧客を見つけてください。',
          wizard_reservation_title: '予約データ',
          wizard_reservation_room_label: '客室 *',
          wizard_reservation_room_subtitle:
            '客室をクリックして選択します。複数の客室を選択できます。',
          wizard_reservation_room_placeholder: '客室を選択',
          wizard_reservation_status_label: '予約ステータス',
          wizard_reservation_status_placeholder: 'ステータスを選択',
          wizard_reservation_checkin_label: 'チェックイン日時 *',
          wizard_reservation_checkin_placeholder: 'チェックイン日時', // プレースホルダーがフルコンテンツにないため追加
          wizard_reservation_checkout_label: 'チェックアウト日時 *',
          wizard_reservation_checkout_placeholder: 'チェックアウト日時', // プレースホルダーがフルコンテンツにないため追加
          wizard_reservation_password_label: '顧客のパスワード',
          wizard_reservation_password_placeholder: '顧客のパスワードを入力',
          wizard_reservation_generate_password: 'パスワードを生成',
          wizard_confirmation_title: '予約の確認',
          wizard_confirmation_customer_data: '顧客データ',
          wizard_confirmation_reservation_data: '予約データ',
          wizard_confirmation_room: '客室',
          wizard_confirmation_capacity: '収容人数',
          wizard_confirmation_price: '価格',
          wizard_confirmation_checkin: 'チェックイン',
          wizard_confirmation_checkout: 'チェックアウト',
          wizard_confirmation_status: 'ステータス',
          wizard_confirmation_password: 'パスワード',
          wizard_confirmation_address: '住所',
          wizard_confirmation_zipcode: '郵便番号',
          wizard_confirmation_gender_male: '男性',
          wizard_confirmation_gender_female: '女性',
          wizard_confirmation_gender_other: 'その他',
          wizard_confirmation_gender_not_informed: '回答しない',
          wizard_buttons_back: '戻る',
          wizard_buttons_cancel: 'キャンセル',
          wizard_buttons_next: '次へ',
          wizard_buttons_create: '作成',
          wizard_page_title: '新規客室予約',
          wizard_page_subtitle: 'ホテル用に新しい予約を作成',
          legend: {
            title: '客室ステータス凡例',
            available: '利用可能',
            selected: '選択済み',
            unavailable: '利用不可',
            occupied: '占有中',
            reserved: '予約済み',
            being_cleaning: '清掃中',
            maintenance: 'メンテナンス中',
            no_info: '情報なし',
          },
        },
        customer_form: {
          title: '顧客データ',
          personal_info_title: '個人情報',
          cpf_label: 'CPF *',
          cpf_placeholder: '000.000.000-00',
          name_label: '氏名 *',
          name_placeholder: '氏名を入力',
          email_label: 'Eメール *',
          email_placeholder: 'Eメールを入力',
          birthdate_label: '生年月日 *',
          gender_label: '性別',
          gender_placeholder: '性別を選択',
          gender_male: '男性',
          gender_female: '女性',
          gender_other: 'その他',
          contact_info_title: '連絡先情報',
          phone_label: '電話 *',
          phone_placeholder: '(11) 99999-9999',
          phone_type_label: '電話の種類',
          phone_type_cell: '携帯電話',
          phone_type_landline: '固定電話',
          whatsapp_optin: 'WhatsAppでのメッセージ受信を許可する',
          address_title: '居住住所',
          cep_label: '郵便番号 *',
          cep_placeholder: '00000-000',
          street_label: '通り *',
          street_placeholder: '通り、大通りなど',
          number_label: '番号 *',
          number_placeholder: '123',
          extra_label: '補足',
          extra_placeholder: 'アパート、ブロックなど',
          district_label: '近隣 *',
          district_placeholder: '近隣の名前',
          city_label: '市 *',
          city_placeholder: '市の名前',
          state_label: '州 *',
          state_placeholder: 'SP',
          reference_label: '参照点',
          reference_placeholder: 'ショッピングモールの近く、広場の向かいなど',
          terms_title: '利用規約',
          accept_terms: '利用規約に同意します *',
          lgpd_consent: '私の個人データの処理を許可します (LGPD) *',
        },
        title: '客室予約',
        subtitle: 'ホテルの予約管理',
        breadcrumb_dashboard: 'ダッシュボード',
        breadcrumb_reservation: '予約',
        btn_new_reservation: '新規予約',
        btn_confirm: '予約を確認',
        btn_checkin: 'チェックインを実行',
        btn_checkout: 'チェックアウトを実行',
        btn_cancel: '予約をキャンセル',
        btn_no_show: 'ノーショーとしてマーク',
        btn_delete: '予約を削除',
        btn_details: '予約の詳細',
        filter_status_label: '予約ステータス',
        filter_status_placeholder: 'ステータスを選択',
        filter_status_all: 'すべてのステータス',
        table_reservation: '予約',
        table_room: '客室',
        table_customer: '顧客',
        table_checkin: 'チェックイン',
        table_checkout: 'チェックアウト',
        table_status: 'ステータス',
        table_price: '価格',
        table_actions: 'アクション',
        status_confirmed: '確認済み',
        status_in_progress: '進行中',
        status_completed: '完了',
        status_cancelled: 'キャンセル済み',
        status_no_show: 'ノーショー',
        status_pending: '保留中',
        msg_success_delete: '削除が正常に実行されました！',
        msg_success_update: '予約ステータスが正常に更新されました！',
        msg_error_delete: '予約の削除中にエラーが発生しました！',
        msg_error_update: '予約ステータスの更新中にエラーが発生しました！',
        msg_confirm_status_change: '予約ステータスを「{status}」に変更してもよろしいですか？',
        msg_confirm_checkin: 'この予約のチェックインを実行してもよろしいですか？',
        msg_confirm_checkout:
          'チェックアウトを完了してもよろしいですか？この操作は元に戻すことはできません。',
        msg_checkout_attention: '⚠️ 注意 - よくお読みください：',
        msg_checkout_list: [
          '顧客はすでに支払いを行っています',
          '未処理の財務的な問題はありません',
          'すべてのサービスが適切に決済されています',
        ],
        msg_checkout_confirm_read: 'すべての検証を確認済みであることを読み、確認します',
        msg_checkout_validation:
          '続行する前に、すべての検証を読み、確認したことを確認する必要があります。',
        msg_confirm_delete: '予約を削除',
        tab_basic: '基本情報',
        tab_summary: '概要',
        tab_activities: 'アクティビティ',
        tab_tours: 'ツアー',
        tab_experiences: '体験',
        tab_services: 'サービス予約',
        tab_services_list: 'サービス一覧',
        tab_orders: 'ホテルの注文',
        label_loading: '読み込み中...',
        label_loading_orders: '注文を読み込み中...',
        label_order_details: '注文の詳細',
        label_no_data: '注文が見つかりません',
        label_pending: '現在、予約されている注文はありません。',
        tab_title: 'ホテルの注文',
        label_order: '注文',
        label_orders: '注文',
        label_total_spent: '合計支出: {value}',
        label_total_orders: '注文の合計',
        label_total_spent_label: '合計支出',
        label_total_paid_label: '合計支払い済み',
        label_products: '製品',
        label_quantity: '数量',
        label_sku: 'SKU',
        label_delivery: '配達',
        label_delivery_address: '配達先住所',
        label_withdraw_address: '集荷先住所',
        label_financial_summary: '財務概要',
        label_products_label: '製品',
        label_delivery_fee: '配達料',
        label_discount: '割引',
        label_total: '合計',
        label_payment_na: '支払い N/A',
        label_payment_offline: 'オフライン支払い',
        label_payment_card: 'カード支払い',
        label_payment_credit: 'クレジット',
      },
      hospitality_room_reservation_tabs: {
        basic_info: {
          tab_title: '基本情報',
          label_customer: '顧客',
          label_room: '客室',
          label_checkin: 'チェックイン',
          label_checkout: 'チェックアウト',
          label_status: 'ステータス',
          label_price: '価格',
          label_notes: '備考',
          placeholder_notes: '予約の備考を追加',
          status_edit_warning: '予約ステータスは、確認またはキャンセル後に編集できません。',
          selected_room_details: '客室 {roomNumber} - {type} (収容人数: {capacity}) - R$ {price}',
          selected_customer_details: '顧客: {name} | メール: {email} | 電話: {phone}',
          optional_checkout: 'チェックアウトはオプションであり、後で入力できます。',
          status_pending: '保留中',
          status_confirmed: '確認済み',
          status_in_progress: '進行中',
          status_completed: '完了',
          status_cancelled: 'キャンセル済み',
          summary_capacity: '収容人数',
          summary_people: '人',
          btn_change_password: 'パスワードを変更',
        },
        summary: {
          tab_title: '概要',
          room_details: '部屋の詳細',
          label_total: '合計',
          label_paid: '支払い済み',
          label_pending: '保留中',
          label_services: 'サービス',
          label_products: '製品',
          label_activities: 'アクティビティ',
          label_experiences: '体験',
          label_tours: 'ツアー',
          label_room: '客室',
          label_customer: '顧客',
          label_checkin: 'チェックイン',
          label_checkout: 'チェックアウト',
          label_status: 'ステータス',
          label_price: '価格',
          label_notes: '備考',
          label_capacity: '収容人数',
          label_people: '人',
          label_orders: 'ホテルの注文',
          label_payment_method: '支払い方法',
          label_discount: '割引',
          label_tax: '税金',
          label_total_with_tax: '税込み合計',
          label_total_with_discount: '割引込み合計',
          label_total_paid: '合計支払い済み',
          label_total_pending: '合計保留中',
          label_summary: '予約概要',
          label_details: '詳細',
          label_edit: '編集',
          label_delete: '削除',
          label_confirm: '確認',
          label_cancel: 'キャンセル',
          label_no_data: 'データなし',
          label_success: '操作が正常に実行されました！',
          label_error: '操作中にエラーが発生しました！',
          label_warning: '注意',
          label_info: '情報',
          label_actions: 'アクション',
          label_service: 'サービス',
          label_product: '製品',
          label_activity: 'アクティビティ',
          label_experience: '体験',
          label_tour: 'ツアー',
          label_order: '注文',
          label_date: '日付',
          label_time: '時間',
          label_type: 'タイプ',
          label_edit_reservation: '予約を編集',
          label_delete_reservation: '予約を削除',
          label_confirm_reservation: '予約を確認',
          label_cancel_reservation: '予約をキャンセル',
          label_status_confirmed: '確認済み',
          label_status_in_progress: '進行中',
          label_status_completed: '完了',
          label_status_cancelled: 'キャンセル済み',
          label_status_no_show: 'ノーショー',
          label_status_pending: '保留中',
        },
        activities: {
          tab_title: 'アクティビティ',
          label_activity: 'アクティビティ',
          label_activities: 'アクティビティ',
          label_no_data: 'アクティビティが見つかりませんでした',
          label_pending: '現在、予約されているアクティビティはありません。',
          label_people: '参加者',
          label_category: 'カテゴリ',
          label_location: '場所',
          label_session_time: 'セッション時間',
          label_skill_level: 'スキルレベル',
          label_special_requests: '特別リクエスト',
          label_price: '価格',
          label_date: '日付',
          label_time: '時間',
          label_status: 'ステータス',
          label_actions: 'アクション',
          label_description: '説明',
          status_confirmed: '確認済み',
          status_pending: '保留中',
          status_cancelled: 'キャンセル済み',
          status_completed: '完了',
          btn_add_activity: 'アクティビティを追加',
        },
        experiences: {
          tab_title: '体験',
          label_experience: '体験',
          label_experiences: '体験',
          label_no_data: '体験が見つかりませんでした',
          label_pending: '現在、予約されている体験はありません。',
          label_people: '参加者',
          label_category: 'カテゴリ',
          label_location: '場所',
          label_session_time: 'セッション時間',
          label_skill_level: 'スキルレベル',
          label_special_requests: '特別リクエスト',
          label_price: '価格',
          label_date: '日付',
          label_time: '時間',
          label_status: 'ステータス',
          label_actions: 'アクション',
          label_description: '説明',
          status_confirmed: '確認済み',
          status_pending: '保留中',
          status_cancelled: 'キャンセル済み',
          status_completed: '完了',
          btn_add_experience: '体験を追加',
          label_duration: '期間',
          label_rating: '評価',
          label_special_occasion: '特別な機会',
          label_includes: '含まれる',
        },
        hotel_orders: {
          tab_title: 'ホテルの注文',
          label_order: '注文',
          label_orders: '注文',
          label_no_data: '注文が見つかりません',
          label_pending: '現在、予約されている注文はありません。',
          label_delivery: '配達',
          label_quantity: '数量',
          label_sku: 'SKU',
          label_delivery_address: '配達先住所',
          label_withdraw_address: '集荷先住所',
          label_financial_summary: '財務概要',
          label_products: '製品',
          label_products_label: '製品',
          label_total_spent: '合計支出: {value}',
          label_total_orders: '注文の合計',
          label_total_spent_label: '合計支出',
          label_total_paid_label: '合計支払い済み',
          label_discount: '割引',
          label_total: '合計',
          label_payment_na: '支払い N/A',
          label_payment_offline: 'オフライン支払い',
          label_payment_card: 'カード支払い',
          label_payment_credit: 'クレジット',
          label_delivery_fee: '配達料',
          no_order_title: '注文が見つかりません',
        },
        tours: {
          tab_title: 'ツアー',
          label_tour: 'ツアー',
          label_tours: 'ツアー',
          label_no_data: 'ツアーが見つかりませんでした',
          label_pending: '現在、予約されているツアーはありません。',
          label_people: '参加者',
          label_duration: '期間',
          label_difficulty: '難易度',
          label_rating: '評価',
          label_transfer_included: '送迎込み',
          label_transfer_yes: '送迎込み',
          label_transfer_no: '送迎なし',
          label_schedule: 'スケジュール',
          label_weather_concerns: '気象に関する懸念',
          label_physical_requirements: '身体的要件',
          label_special_requests: '特別リクエスト',
          label_price: '価格',
          label_date: '日付',
          label_time: '時間',
          label_status: 'ステータス',
          label_actions: 'アクション',
          label_description: '説明',
          status_confirmed: '確認済み',
          status_pending: '保留中',
          status_cancelled: 'キャンセル済み',
          status_completed: '完了',
          btn_add_tour: 'ツアーを追加',
        },
        services: {
          title: 'サービス予約',
          subtitle: '予約されたサービスの詳細',
          no_services: '予約されたサービスはありません',
          service_info: 'サービス情報',
          service_name: 'サービス名',
          service_type: 'サービスタイプ',
          description: '説明',
          room_info: '部屋情報',
          room_number: '部屋',
          booking_details: '予約詳細',
          status: 'ステータス',
          check_in: 'チェックイン',
          check_out: 'チェックアウト',
          guest_name: 'ゲスト名',
          reservation_name: '予約名',
          number_of_rooms: '部屋数',
          number_of_guests: 'ゲスト数',
          adults: '大人',
          children: '子供',
          total_price: '合計金額',
          price_per_night: '1泊あたりの料金',
          nights: '泊',
          additional_info: '追加情報',
          booking_date: '予約日',
          reservation_code: '予約コード',
          payment_status: '支払いステータス',
          special_requests: '特別なリクエスト',
          service_details: 'サービス詳細',
          view_details: '詳細を見る',
          total_services: '合計サービス',
          active_services: 'アクティブなサービス',
          pending_services: '保留中のサービス',
          completed_services: '完了したサービス',
          service_image: 'サービス画像',
          no_image: '画像がありません',
        },
        services_list: {
          title: 'サービス一覧',
          subtitle: 'すべての予約されたサービス',
          search_placeholder: '名前、部屋、ゲストで検索...',
          filter_all: 'すべて',
          filter_active: 'アクティブ',
          filter_pending: '保留中',
          filter_completed: '完了',
          table_service_name: 'サービス',
          table_service_type: 'タイプ',
          table_room: '部屋',
          table_guest: 'ゲスト',
          table_checkin: 'チェックイン',
          table_checkout: 'チェックアウト',
          table_status: 'ステータス',
          table_price: '料金',
          table_actions: 'アクション',
          status_active: 'アクティブ',
          status_pending: '保留中',
          status_completed: '完了',
          status_cancelled: 'キャンセル',
          no_services: 'サービスが見つかりません',
          no_services_desc: '条件に一致するサービスはありません',
          showing: '表示中',
          of: '/',
          services: 'サービス',
          items_per_page: 'ページごとのアイテム',
          page: 'ページ',
          previous: '前へ',
          next: '次へ',
          view_details: '詳細を見る',
          total_found: '合計見つかった',
          active_filters: 'アクティブフィルター',
          clear_filters: 'フィルターをクリア',
          filter_by_status: 'ステータスでフィルター',
          search_active: '検索アクティブ',
          rooms: '部屋',
          guests: 'ゲスト',
          nights: '泊',
          loading: 'サービスを読み込み中...',
          error: 'サービスの読み込みエラー',
          retry: '再試行',
          export: 'エクスポート',
          refresh: '更新',
        },
      },
      hospitality_hotel_room: {
        label_room_number: '客室番号 *',
        image: '客室の画像',
        placeholder_room_number: '例: 101、A201、プレジデンシャルスイート',
        max_20_chars: '最大 20 文字',
        label_status: 'ステータス',
        label_capacity: '収容人数（人）',
        placeholder_capacity: '例: 2',
        label_price: '価格（R$）',
        placeholder_price: '例: 150.00',
        label_type: '客室タイプ',
        title: 'ホテルの客室',
        subtitle: 'ホテルの客室管理',
        create_multiples: '複数の客室を作成',
        add_room: '客室を追加',
        header_number: '番号',
        header_status: 'ステータス',
        header_type: 'タイプ',
        header_capacity: '収容人数',
        header_price: '価格',
        header_actions: 'アクション',
        action_edit: '客室を編集',
        action_delete: '客室を削除',
        modal_bulk_title: '複数の客室を作成',
        modal_bulk_prefix: 'プレフィックス（オプション）',
        modal_bulk_prefix_placeholder: '例: A、B、1F',
        modal_bulk_start: '開始番号 *',
        modal_bulk_start_placeholder: '101',
        modal_bulk_end: '終了番号 *',
        modal_bulk_end_placeholder: '110',
        modal_bulk_capacity: '収容人数',
        modal_bulk_capacity_placeholder: '2',
        modal_bulk_price: '価格',
        modal_bulk_price_placeholder: '150.00',
        modal_bulk_type: 'タイプ',
        type_single: 'シングル',
        type_double: 'ダブル',
        type_twin: 'ツイン',
        type_queen: 'クイーン',
        type_king: 'キング',
        type_suite: 'スイート',
        type_junior_suite: 'ジュニアスイート',
        type_master_suite: 'マスタースイート',
        type_presidential: 'プレジデンシャル',
        type_family: 'ファミリー',
        type_accessible: 'バリアフリー',
        modal_bulk_cancel: 'キャンセル',
        modal_bulk_create: '客室を作成',
        breadcrumb_dashboard: 'ダッシュボード',
        breadcrumb_hotel_room: 'ホテルの客室',
        create_title: 'ホテルの客室を作成',
        create_subtitle: 'ホテルに新しい客室を追加',
        edit_title: 'ホテルの客室を編集',
        edit_subtitle: '客室 #{room} の情報を編集',
        breadcrumb_create: '客室を作成',
        breadcrumb_edit: '客室を編集',
      },
      hospitality_experiences: {
        tab_basic: '基本情報',
        edit: '体験を編集',
        edit_subtitle: '体験情報を更新',
        create: '体験を作成',
        create_subtitle: '詳細を入力して新しい体験を作成',
        tab_details: '詳細な項目',
        tab_image: '画像',
        tab_schedules: 'スケジュール',
        list_title: 'ホテルの体験',
        list_subtitle: 'ホテルのすべての体験を管理',
        field_title: 'タイトル',
        field_title_placeholder: '例: 専用のロマンチックなディナー',
        field_description: '説明',
        field_description_placeholder: '提供される体験を詳細に説明します...',
        field_image: '新しい画像',
        field_price: '価格（R$）',
        field_price_placeholder: '0.00',
        field_duration: '期間',
        field_duration_placeholder: '例: 2 時間',
        field_type: '体験のタイプ',
        field_rating: '評価（0-5）',
        field_rating_placeholder: '0',
        field_status: 'アクティブステータス',
        field_includes: '含まれる項目',
        field_includes_placeholder: '例: シャンパン、特別な装飾...',
        field_show_additional_services: '事前定義されたサービスオプションを表示',
        field_actions: 'アクション',
        status_active: 'アクティブ',
        status_inactive: '非アクティブ',
        no_rating: '評価なし',
        no_includes: '含まれる項目なし',
        currency: 'R$',
        btn_add: '体験を追加',
        btn_edit: '編集',
        btn_delete: '削除',
        btn_update: '体験を更新',
        btn_create: '体験を作成',
        btn_remove: '削除',
        btn_add_item: '項目を追加',
        edit_title: '体験を編集',
        create_title: '体験を作成',
        msg_success_create: '体験が正常に作成されました！',
        msg_success_update: '体験が正常に更新されました！',
        msg_success_delete: '体験が削除されました',
        msg_success_delete_text: '体験が正常に削除されました！',
        msg_error_create: '体験の作成中にエラーが発生しました',
        msg_error_update: '体験の更新中にエラーが発生しました',
        msg_error_delete: '体験の削除中にエラーが発生しました',
        msg_error_delete_text: '体験を削除できませんでした！',
        msg_error_load: '体験の読み込み中にエラーが発生しました',
        msg_error_load_text: '体験データを読み込めませんでした！',
        msg_error_required_title: 'タイトルは必須です！',
        msg_error_title_length: 'タイトルは最大 255 文字である必要があります！',
        msg_error_required_description: '説明は必須です！',
        msg_error_required_price: '価格は必須です！',
        msg_error_price_negative: '価格はゼロ以上である必要があります！',
        msg_error_required_duration: '期間は必須です！',
        msg_error_duration_length: '期間は最大 100 文字である必要があります！',
        msg_error_required_includes: '少なくとも1つの項目が含まれている必要があります！',
        msg_error_rating_range: '評価は 0 から 5 の間である必要があります！',
        field_order: '順序',
        field_order_placeholder: '例: 1, 2, 3...',
        header_order: '順序',
        msg_error_order_negative: '順序はゼロ以上である必要があります！',
      },
      entertainment_services: {
        list_title: 'エンターテイメントサービス',
        list_subtitle: '利用可能なエンターテイメントサービスを管理する',
        create: 'エンターテイメントサービスを作成',
        create_subtitle: '新しいサービスを作成するために詳細を入力してください',
        create_title: 'エンターテイメントサービスを作成',
        edit: 'エンターテイメントサービスを編集',
        edit_subtitle: 'サービス情報を更新',
        edit_title: 'エンターテイメントサービスを編集',
        field_title: 'タイトル',
        field_title_placeholder: '例：スパとマッサージ',
        field_type: 'サービスタイプ',
        field_status: 'アクティブステータス',
        field_actions: 'アクション',
        type_experience: 'エンターテイメント体験',
        type_activity: 'エンターテイメントアクティビティ',
        type_tour: 'エンターテイメントツアー',
        status_active: 'アクティブ',
        status_inactive: '非アクティブ',
        btn_add: 'サービスを追加',
        btn_edit: '編集',
        btn_delete: '削除',
        btn_update: 'サービスを更新',
        btn_create: 'サービスを作成',
        btn_search: '検索',
        btn_clear: 'クリア',
        search_placeholder: 'タイトルで検索...',
        msg_success_create: 'サービスが正常に作成されました！',
        msg_success_update: 'サービスが正常に更新されました！',
        msg_success_delete: 'サービスが削除されました',
        msg_success_delete_text: 'サービスが正常に削除されました！',
        msg_error_create: 'サービスの作成中にエラーが発生しました',
        msg_error_update: 'サービスの更新中にエラーが発生しました',
        msg_error_delete: 'サービスの削除中にエラーが発生しました',
        msg_error_delete_text: 'サービスを削除できませんでした！',
        msg_error_load: 'サービスの読み込み中にエラーが発生しました',
        msg_error_load_text: 'サービスデータを読み込めませんでした！',
        msg_error_required_title: 'タイトルは必須です！',
        msg_error_title_length: 'タイトルは最大255文字である必要があります！',
      },
      hospitality_activities: {
        hotel_reservation: {
          page_title: 'サービスの予約',
          details_title: '予約の詳細',
          cancel_title: '予約をキャンセル',
          cancel_reason_label: 'キャンセルの理由 *',
          cancel_reason_placeholder: 'キャンセルの理由を選択',
          cancel_reason_select: '理由を選択',
          type_tour: 'ツアー',
          type_experience: '体験',
          type_activity: 'アクティビティ',
          type_room_service: 'ルームサービス',
          status_pending: '保留中',
          status_confirmed: '確認済み',
          status_cancelled: 'キャンセル済み',
          status_completed: '完了',
          error_title: 'エラー',
          error_load: '予約の読み込み中にエラーが発生しました！',
          error_details: '予約の詳細の読み込み中にエラーが発生しました！',
          error_cancel: '予約のキャンセル中にエラーが発生しました！',
          success_title: '成功',
          success_cancel: '予約が正常にキャンセルされました！',
          warning_title: '注意',
          warning_cancel_reason: 'キャンセルの理由を選択してください。',
          no_details: 'この種の予約には特定の詳細はありません。',
          reasons_tour: [
            '計画の変更',
            '気象の問題',
            'スケジュールの競合',
            '健康上の理由',
            'ホテルによるキャンセル',
          ],
          reasons_experience: [
            '滞在日の変更',
            '特別な機会のキャンセル',
            'スケジュールの競合',
            '個人的な理由',
            '別のサービスを希望',
          ],
          reasons_activity: [
            '準備ができていないと感じた',
            'スケジュールの競合',
            '健康上の問題',
            '計画の変更',
            'アクティビティが期待を満たさない',
          ],
          reasons_room_service: [
            '計画の変更',
            'サービスが不要',
            'スケジュールの競合',
            '個人的な理由',
            '別のサービスを希望',
          ],
        },
        create_title: 'ホテルのアクティビティを作成',
        create_subtitle: 'ホテルに新しいアクティビティを追加',
        edit_title: 'ホテルのアクティビティを編集',
        edit_subtitle: 'アクティビティ情報を更新',
        list_title: 'ホテルのアクティビティ',
        list_subtitle: 'アクティビティとエンターテイメントの管理',
        field_title: 'アクティビティのタイトル *',
        field_title_placeholder: '例: ヨガクラス、音楽ショー、子供向けレクリエーション',
        field_title_hint: '最大 255 文字',
        field_time: '時間 *',
        field_time_placeholder: '例: 08:00 - 09:00、毎日 15時',
        field_time_hint: '最大 100 文字',
        field_description: '説明 *',
        field_description_placeholder:
          'アクティビティ、その利点、ゲストが期待できることなどを詳細に説明します...',
        field_image: 'アクティビティの画像',
        field_location: '場所 *',
        field_location_placeholder: '例: メインプール、イベントホール、ビーチ',
        field_location_hint: '最大 255 文字',
        field_capacity: '収容人数 *',
        field_capacity_placeholder: '例: 20, 0の場合は無制限',
        field_capacity_hint: '最大 50 文字',
        field_period: '期間 *',
        field_period_placeholder: '例: 00:15、01:00、00:30',
        field_category: 'カテゴリ *',
        field_age_group: '年齢層',
        field_price: '価格（R$）',
        field_price_placeholder: '0.00（無料の場合は空欄）',
        field_price_hint: '無料のアクティビティの場合は空欄',
        field_requires_reservation: '予約が必要',
        field_requires_reservation_hint: 'アクティビティに事前の予約が必要な場合はチェック',
        field_is_active: 'アクティビティを有効化',
        field_is_active_hint: 'チェックを外すとアクティビティを一時的に無効にします',
        btn_edit: 'アクティビティを編集',
        btn_delete: 'アクティビティを削除',
        btn_create: 'アクティビティを作成',
        btn_cancel: 'キャンセル',
        msg_success_create: 'アクティビティが正常に作成されました！',
        msg_success_update: 'アクティビティが正常に更新されました！',
        msg_success_delete: 'アクティビティが正常に削除されました！',
        msg_error_create: 'アクティビティの作成中にエラーが発生しました！',
        msg_error_update: 'アクティビティの更新中にエラーが発生しました！',
        msg_error_delete: 'アクティビティの削除中にエラーが発生しました！',
        msg_error_load: 'アクティビティの読み込み中にエラーが発生しました！',
        msg_error_required_title: 'タイトルは必須です！',
        msg_error_title_length: 'タイトルは最大 255 文字である必要があります！',
        msg_error_required_description: '説明は必須です！',
        msg_error_required_time: '時間は必須です！',
        msg_error_time_length: '時間は最大 100 文字である必要があります！',
        msg_error_required_location: '場所は必須です！',
        msg_error_location_length: '場所は最大 255 文字である必要があります！',
        msg_error_required_capacity: '収容人数は必須です！',
        msg_error_capacity_length: '収容人数は最大 50 文字である必要があります！',
        msg_error_price_negative: '価格はゼロ以上である必要があります！',
        remove_schedule: 'スケジュールを削除',
        confirm_remove_schedule: 'このスケジュールを削除してもよろしいですか？',
        schedule_seasonal_start: 'シーズンの開始',
        schedule_seasonal_end: 'シーズンの終了',
        schedule_start_time: '開始時間',
        schedule_end_time: '終了時間',
        add_schedule: 'スケジュールを追加',
        schedule_time: '時間 *',
        schedule_time_placeholder: '例: 08:00 - 09:00、毎日 15時',
        schedule_description: '説明 *',
        schedule_days_of_week: '曜日',
        schedule_status: 'スケジュールを有効化',
        schedule_seasonal_hint: '該当する場合は季節期間を定義します',
        field_duration_hint: '期間を時間と分で指定 (例: 2時間30分)',
        field_duration_placeholder: '期間を時間と分で指定 (例: 2時間30分)',
        field_order: '順序',
        field_order_placeholder: '例: 1, 2, 3...',
        msg_error_order_negative: '順序はゼロ以上である必要があります！',
      },
      hotel_tour: {
        create_title: 'ホテルツアーを作成',
        create_subtitle: 'ホテルに新しいツアーを追加',
        edit_title: 'ホテルツアーを編集',
        edit_subtitle: 'ツアー情報を更新',
        list_title: 'ホテルツアー',
        list_subtitle: 'ツアーとエクスカーションの管理',
        field_title: 'ツアーのタイトル *',
        field_difficulty: '難易度',
        field_duration: '期間',
        field_rating: '評価',
        field_participants: '参加者',
        field_schedules: 'スケジュール',
        field_includes: '含まれるもの',
        field_transfer: '送迎',
        field_currency: '通貨',
        field_currency_hint: '通貨コード（例: BRL、USD）',
        currency_brl: 'レアル（BRL）',
        currency_usd: 'ドル（USD）',
        currency_eur: 'ユーロ（EUR）',
        field_rating_placeholder: '0.0',
        field_rating_hint: '0から5つ星の評価',
        field_participants_min: '最小参加者 *',
        field_participants_min_hint: '最小参加者数',
        field_participants_max: '最大参加者',
        field_participants_max_placeholder: '無制限の場合は空欄',
        field_participants_max_hint: '最大参加者数（オプション）',
        field_age_restriction: '年齢制限',
        field_age_restriction_placeholder: '例: 12歳以上、18歳未満には非推奨',
        field_age_restriction_hint: '年齢制限（オプション）',
        field_physical_requirements: '身体的要件',
        field_physical_requirements_placeholder: '例: 良好な体調、長距離を歩く能力',
        field_physical_requirements_hint: '必要な身体的要件（オプション）',
        field_cancellation_hours: 'キャンセル（時間） *',
        field_cancellation_hours_hint: 'キャンセルまでの時間',
        field_discount_children: '子供割引（%）',
        field_discount_children_hint: '割引率',
        field_weather_dependent: '天候に依存',
        field_weather_dependent_hint: '気象条件に依存する場合はチェック',
        field_is_active: 'ツアーを有効化',
        field_is_active_hint: 'チェックを外すと一時的に無効にします',
        tab_basic: '基本情報',
        tab_details: '詳細と設定',
        tab_schedules: 'スケジュール',
        tab_includes: '含まれる項目',
        tab_image: '画像',
        no_schedule_added: 'スケジュールが追加されていません',
        click_add_schedule: '「スケジュールを追加」をクリックして開始します。',
        includes_title: 'ツアーに含まれる項目',
        selected: '選択済み',
        field_image_hint: 'ツアーを代表する画像を選択します',
        update_info: 'ツアー情報を更新',
        field_title_placeholder: '例: 市内観光、ビーチエクスカーション、歴史散策',
        field_title_hint: '最大 255 文字',
        field_time: '時間 *',
        field_time_placeholder: '例: 08:00 - 09:00、毎日 15時',
        field_time_hint: '最大 100 文字',
        field_description: '説明 *',
        field_description_placeholder:
          'ツアー、ハイライト、ゲストが期待できることなどを説明します...',
        field_image: 'ツアーの画像',
        field_location: '場所 *',
        field_location_placeholder: '例: センター、ビーチ、博物館',
        field_location_hint: '最大 255 文字',
        field_capacity: '収容人数 *',
        field_capacity_placeholder: '例: 20名、無制限、10-15名参加',
        field_capacity_hint: '最大 50 文字',
        field_category: 'カテゴリ *',
        field_price: '価格（R$）',
        field_price_placeholder: '0.00（無料の場合は空欄）',
        field_price_hint: '無料ツアーの場合は空欄',
        field_requires_reservation: '予約が必要',
        field_requires_reservation_hint: 'ツアーに事前の予約が必要な場合はチェック',
        btn_edit: 'ツアーを編集',
        btn_delete: 'ツアーを削除',
        btn_create: 'ツアーを作成',
        btn_cancel: 'キャンセル',
        table_title: 'タイトル',
        table_time: '時間',
        table_location: '場所',
        table_category: 'カテゴリ',
        table_price: '価格',
        table_capacity: '収容人数',
        table_actions: 'アクション',
        msg_success_create: 'ツアーが正常に作成されました！',
        msg_success_update: 'ツアーが正常に更新されました！',
        msg_success_delete: 'ツアーが正常に削除されました！',
        msg_error_create: 'ツアーの作成中にエラーが発生しました！',
        msg_error_update: 'ツアーの更新中にエラーが発生しました！',
        msg_error_delete: 'ツアーの削除中にエラーが発生しました！',
        msg_error_load: 'ツアーの読み込み中にエラーが発生しました！',
        msg_error_required_title: 'タイトルは必須です！',
        msg_error_title_length: 'タイトルは最大 255 文字である必要があります！',
        msg_error_required_description: '説明は必須です！',
        msg_error_required_time: '時間は必須です！',
        msg_error_time_length: '時間は最大 100 文字である必要があります！',
        msg_error_required_location: '場所は必須です！',
        msg_error_location_length: '場所は最大 255 文字である必要があります！',
        msg_error_required_capacity: '収容人数は必須です！',
        msg_error_capacity_length: '収容人数は最大 50 文字である必要があります！',
        msg_error_price_negative: '価格はゼロ以上である必要があります！',
        schedule_start_time: '開始時間',
        schedule_end_time: '終了時間',
        add_schedule: 'スケジュールを追加',
        schedule_time: '時間 *',
        schedule_time_placeholder: '例: 08:00 - 09:00、毎日 15時',
        schedule_description: '説明 *',
        schedule_days_of_week: '曜日',
        schedule_status: 'スケジュールを有効化',
        schedule_seasonal_hint: '該当する場合は季節期間を定義します',
        field_duration_hint: '期間を時間と分で指定 (例: 2h30min)',
        field_duration_placeholder: '期間を時間と分で指定 (例: 2h30min)',
        schedule_seasonal_start: 'シーズンの開始',
        schedule_seasonal_end: 'シーズンの終了',
        difficult: {
          easy: '簡単',
          medium: '中程度',
          hard: '難しい',
          extreme: '極端',
        },
        field_order: '順序',
        field_order_placeholder: '例: 1, 2, 3...',
        header_order: '順序',
        msg_error_order_negative: '順序はゼロ以上である必要があります！',
      },
      months: {
        jan: '1月',
        feb: '2月',
        mar: '3月',
        apr: '4月',
        may: '5月',
        jun: '6月',
        jul: '7月',
        aug: '8月',
        sep: '9月',
        oct: '10月',
        nov: '11月',
        dec: '12月',
      },
      permissions: {
        color_variations: 'カラーバリエーション',
        content: 'Webアプリのインターフェース',
        buttons: 'ボタン',
        sessions: 'セッション',
        food: 'スマートオーダー',
        smartorder: '製品管理',
        category: 'カテゴリ',
        subcategory: 'サブカテゴリ',
        product: '製品',
        mark: 'ブランド',
        grid: 'グリッド',
        variation: 'バリエーション',
        catalog: 'カタログ',
        integration: '統合',
        int_pos: 'POS',
        int_gateway: '支払い方法',
        messaging: 'メッセージング',
        sms: 'ステータスとSMS',
        multichannel: 'マルチチャネル',
        report: 'レポート',
        saleorder: '注文',
        indicators: 'インジケータ',
        orderReport: '注文',
        imports: '画像インポート',
        importProductImage: '製品',
        importProductImageSKU: 'バリエーション',
        importCategoryImage: 'カテゴリ',
        customers: '顧客',
        customer_report: '顧客リスト',
        measurement_unit: '測定単位',
        logs: 'ログ',
        settings: '設定',
        charge_integration: 'ロード',
        summaryAccess: 'アクセス',
        sellerAccess: '販売者ダッシュボード',
        managerAccess: 'マネージャーダッシュボード',
        managerGroupAccess: 'グループマネージャーダッシュボード',
        orders: '注文',
        support: 'サポート',
        translate: '言語と関係',
        application: 'Webアプリ',
        messenger: 'メッセージング',
        others: 'その他',
        settings_store: '店舗設定',
        settings_hotel: '設定',
        modalities: 'モダリティ',
        delivery_tax: '配送料',
        shifts: 'シフト',
        whatsappweb: 'WhatsApp Web',
        filemanager: 'ファイルマネージャー',
        payment_plans: '支払いプラン',
        settings_account: 'アカウント設定',
        account: 'アカウント',
        groups: 'グループ',
        users: 'ユーザー',
        terms: '規約',
        highlights: 'ハイライト',
        menu: 'メニュー',
        productReport: '製品',
        optional: '追加項目のリスト',
        locations: 'セクター',
        stores_location: '施設',
        message_hotel: 'ステータスと通知',
        service: 'サービス',
        service_items: 'サービス',
        service_category: 'カテゴリ',
        feed: 'フィード',
        structured_content: '必須サービス',
        orders_room_service: '客室注文',
        orders_activities: 'アクティビティ注文',
        queue: '待機列',
        queue_config: '設定',
        queue_manager: '管理',
        checkout: '顧客データ',
        booking: '予約',
        booking_management: '管理',
        booking_config: '設定',
        booking_environment: '環境',
        booking_day: '本日の予約',
        booking_report: 'レポート',
        booking_managerday: '本日の管理',
        booking_management_dashboard: '予約管理ダッシュボード',
        table_management: 'テーブル管理',
        table_allocation_report: 'テーブル割り当てレポート',
        table_management_dashboard: 'テーブル管理ダッシュボード',
        liveShop: 'ライブコマース',
        icon_library: 'アイコンライブラリ',
        stores: '店舗/顧客',
        segments: 'セグメント',
        payment: '支払い',
        serviceCategory: 'サービスカテゴリ',
        SDS: 'KDS',
        sds_manage: 'マイKDS',
        sds_layout: 'パーソナライズ',
        sds_link: '設定',
        sds_display: 'ディスプレイ',
        /* アグリゲーター */
        config: '設定',
        config_account: 'アカウントデータ',
        config_sector: '活動セクター',
        config_user: 'ユーザー',
        config_term: '規約',
        subCategory: 'サブカテゴリ',
        footer: 'フッターリソース',
        footerFeature: 'リソースを有効化',
        footerContent: 'リソースフィード',
        footerContentAddEdit: 'リソース',
        webapp: 'パーソナライズ',
        webapp_qrcode: 'QRコードを生成',
        ia_menu: '人工知能',
        ia_config: '設定',
        ia_fit: 'トレーニング',
        ia_file_manager: 'ファイルマネージャー',
        ia_folders: 'フォルダ',
        ia_files: 'ファイル',
        ia_settings: '設定',
        ia_folders_blank: 'フォルダが見つかりません',
        ia_filter: 'フィルタ',
        ia_recharge: 'リチャージ',
        ia_final_date: '終了日',
        ia_initial_date: '開始日',
        summarize: 'ダッシュボード',
        consumption: 'AI消費量',
        ct_account: '消費量と価格',
        ct_s3_account: 'S3アカウント',
        ct_data_cost_account: 'データとコスト',
        publication_highlight_banner: 'ハイライトバナー',
        publication: '広告',
        cost: 'コスト',
        security_settings: 'セキュリティ設定',
        coupon: 'クーポン',
        clean_safe: '清潔と安全',
        service_requests: 'サービスフォーム',
        grid_hotel: 'サービスグリッド',
        /* ホスピタリティ */
        hotel_maintenance: 'メンテナンス',
        hotel_room: '客室',
        hotel_reservation: '客室予約',
        hotel_activities_experiences: 'アクティビティと体験',
        hotel_activities: 'アクティビティ',
        hotel_tour: 'ホテルツアー',
        hotel_tour_schedules: 'ホテルツアースケジュール',
        hotel_tour_reservation: '一般予約',
        hotel_experiences: '体験',
        hotel_info: '情報',
        hotel_reservations: '予約',
        hotel_schedules: 'ホテルのプログラム',
        publication_banner: 'バナー',
        feed_back: 'フィードバック',
        feedback_satisfaction: 'アンケートと満足度',
        grid_hotel_feedback: '評価',
        feedback_list: 'フォーム',
        feedback: 'フィードバック',
        post: '投稿',
        post_category: '投稿カテゴリ',
        post_content: '投稿内容',
        booking_hotel: '予約管理',
        grid_hotel_booking: 'サービスグリッド',
        booking_config_hotel: 'サービスの予約',
        page_publications: 'ページの公開',
        communication: 'コミュニケーション',
        communicationCenter: 'コミュニケーションセンター',
        hotel_management: 'ホテル管理',
        hotel_management_entertainment: 'エンターテイメント',
        product_color_variations: '色のバリエーション',
      },
      // Translations for Color Variations Workbench
      workbench: {
        page_title: '色のバリエーション',
        page_subtitle: '製品の色のバリエーションを管理する',
        breadcrumb_dashboard: 'ダッシュボード',
        breadcrumb_workbench: '色ワークベンチ',

        // Mode Selection
        select_mode: 'モードを選択',
        choose_mode: '製品またはバリエーションで作業することを選択してください',
        mode_product: '製品',
        mode_product_description: 'ストアに登録されている製品から選択してください',
        mode_variation: 'バリエーション',
        mode_variation_description: '登録されているバリエーションから選択してください',

        // Product/Variation Selection
        select_product: '製品を選択',
        select_variation: 'バリエーションを選択',
        no_products_found: '製品が見つかりません',
        no_variations_found: 'バリエーションが見つかりません',
        back_button: '戻る',
        noImagesFound: 'この製品/バリエーションに画像が見つかりません',
        description:
          'カスタムカラーバリエーションの作成を開始するには、製品またはバリエーションを選択してください。',

        // Image and Color Selection
        select_image: '画像を選択',
        select_color: '色を選択',
        color_description: '説明（オプション）',
        description_placeholder: 'あなたが加えたい変更を説明してください...',
        select_image_first: 'まず画像を選択してください',
        processing_error: 'バリエーション処理中にエラーが発生しました',

        // Buttons
        generate_variation: 'バリエーションを生成',
        processing: '処理中...',
        processing_time_seconds: '{time}秒',

        // Preview
        selected_image_preview: '選択された画像のプレビュー',
        result_preview: '結果のプレビュー',
        original_image: '元の画像',
        processed_image: '処理済みの画像',
        target_color: 'ターゲットカラー',
        processing_time: '処理時間',

        // Actions
        approve_and_apply: '承認して適用',
        reject: '却下',
        apply_variation: 'バリエーションを適用',
        apply_target: 'このバリエーションをどこに適用しますか？',

        // Apply Dialog
        create_new_variation: '新しいバリエーションを作成',
        new_variation_info: 'この画像で新しいバリエーションが作成されます',
        replace_existing_variation: '既存のバリエーションを置換',
        select_variation_to_replace: '置き換えるバリエーションを選択してください',
        replace_product_image: '製品画像を置換',
        select_product_to_replace_image: 'どの製品画像を置き換えるかを選択してください',

        // Messages
        variation_saved_success: 'バリエーションが正常に保存されました！',
        error_saving_variation: 'バリエーション保存中にエラーが発生しました',
        success_title: '成功',
        error_title: 'エラー',
        warning_title: '警告',

        // Dialog Buttons
        cancel: 'キャンセル',
        save: '保存',
        confirm: '確認',
        close: '閉じる',
      },
      customer: {
        select_group: 'グループを選択',
        select: '選択',
        create: '顧客を作成',
        create_group: 'グループを作成',
        edit: '顧客を表示',
        search_custom: '検索...',
        customer: '顧客',
      },

      buttons: {
        create: '作成',
        back: '戻る',
        previous: '前へ',
        register_pluginspace: 'Pluginspaceを登録',
        access: 'アクセス',
        add_modality: 'モダリティを追加',
        add_km: 'Kmを追加',
        zip_code_list: '郵便番号リスト',
        add_zip_code: '郵便番号を追加',
        area: '配送料エリア',
        list_of_negative_renge_zip_code: 'ネガティブ郵便番号リスト',
        add_negative_zip_code: 'ネガティブ郵便番号を追加',
        add_user: 'ユーザーを追加',
        generate_password: 'パスワードを生成',
        generate_sku: 'SKUを生成',
        add_group: 'グループを追加',
        save: '保存',
        add_term: '規約を追加',
        add_integration: '統合を追加',
        filter: 'フィルタ',
        search: '検索',
        register_product: '製品を登録',
        choose_files: 'ファイルを選択',
        add_categories: 'カテゴリを追加',
        add_subcategories: 'サブカテゴリを追加',
        add_brand: 'ブランドを追加',
        close: '閉じる',
        add_grade: 'グリッドを追加',
        add: '追加',
        add_variation: 'バリエーションを追加',
        confirm_grades: 'グリッドを確認',
        add_catalog: 'カタログを追加',
        generete_qr_code: 'QRコードを生成',
        personalize: 'パーソナライズ',
        settings: '設定',
        add_interval: '間隔を追加',
        add_gateway: 'ゲートウェイを追加',
        overview: '概要',
        view: '表示',
        load_csv: 'ファイルをロード',
        download_csv: '標準XLSXをダウンロード',
        att_page: 'ページを更新',
        export: 'エクスポート',
        add_service: 'サービスを登録',
        add_environment: '環境を追加',
        generate_ia: '提案',
        clear_table_card: 'テーブルまたはコマンドをクリア',
        propose_image: '画像を提案',
        cancel: 'キャンセル',
        next: '次へ',
      },

      global: {
        success: '成功',
        error: 'エラー',
        warning: '注意',
        active: 'アクティブ',
        inactive: '非アクティブ',
      },

      modals: {
        warning_confirm: 'よろしいですか？',
        warning_save: '保存',
        warning_close: '閉じる',
        text_close: '閉じる',
      },

      general: {
        delete_item: 'この項目を削除してもよろしいですか？',
        delete_product_observation: 'この製品のバリエーションも削除されますが、続行しますか？',
        delete_classification_observation:
          'このカテゴリを削除すると、関連するすべての製品が一般カテゴリに移動します。続行しますか？',
        delete: '削除',
        edit: '編集',
        duplicate: '複製',
        attention: '注意',
        actions: 'アクション',
        select: '選択',
        here_are_listed_the_modalities_along_with_their_respective_actions:
          '項目とそれに対応するアクションをここに示します',
        fill_in_the_information_below_and_click_on_the_create_button_to_save_the_changes:
          '以下の情報を入力し、「作成」ボタンをクリックして変更を保存してください',
        save_changes_edit: '以下の情報を入力し、「保存」ボタンをクリックして変更を確定してください',
        save_changes_duplicate:
          '以下の情報を検証または変更し、「保存」ボタンをクリックして変更を確定してください',
        active: 'アクティブ',
        inactive: '非アクティブ',
        showing: '表示中',
        of: 'の',
        to: 'から',
        records: 'レコード',
        type: 'タイプ',
        today: '今日',
        copy: 'コピー',
        linkS3: 'リンク',
        linkedS3: 'リンク済み',
        downloadS3: 'ダウンロード',
        downloadedS3: 'ダウンロード開始',
        copied: 'コピーされました',
        copy_link: '販売者リンクをコピー',
        test: 'テスト',
        success: '成功',
        error: 'エラー',
        email: 'メール',
        paymentFree: '無料',
      },

      pluginspaces: {
        hospitality: 'ホテル',
        food: 'フード',
        healthcare: '医療',
        varejo: '小売',
        fashion: 'ファッション',
      },

      dashboard: {
        totals_by_products: '製品別合計',
        totals_by_category: 'カテゴリ別合計',
        last_orders: '最新の注文',
        products: '製品',
        quantity: '数量',
        total: '合計',
        category: 'カテゴリ',
        welcome: 'Ninegridへようこそ',
        describe_dashboard:
          'ここでは、店舗をシンプルかつ効率的に管理するためのすべてのツールが用意されています。サイドメニューを探索して機能をナビゲートしてください。良い仕事をしてね！',
      },

      modalities: {
        modalities: 'モダリティ',
        modalitie: 'モダリティ',
        here_are_listed_the_modalities_along_with_their_respective_actions:
          'モダリティとそれに対応するアクションをここに示します',
        delivery: '配達',
        withdraw: '持ち帰り',
        active: 'アクティブ',
        inactive: '非アクティブ',
        name: '名前',
        code: 'コード',
        actions: 'アクション',
        search: '検索',
        type: 'タイプ',
        sector_name: 'セクター名',
        table: 'テーブル',
        room: '客室',
        counter: 'カウンター',
        internal: '内部配達',
        synkar: 'Synkar',
      },

      delivery_fee: {
        delivery_fee: '配送料',
        create_delivery_fee: '配送料を作成',
        edit_delivery_fee: '配送料を編集',
        fill_in_the_information_below_and_click_on_the_create_button_to_save_the_changes:
          '以下の情報を入力し、「作成」ボタンをクリックして変更を保存してください',
        save_changes_edit: '以下の情報を入力し、「保存」ボタンをクリックして変更を確定してください',
        km_min: '最小Km',
        km_max: '最大Km',
        value: '価格',
        actions: 'アクション',
        patterns: 'インポートパターン',
        import_file:
          'ファイルをインポートするには、ファイルの最初のセルが次のいずれかのパターンに従う必要があります：',
        import_delivery: '範囲でインポートする場合：km_min、km_max、価格',
        import_cep: '郵便番号でインポートする場合：cep_start、cep_end、価格',
        import_cep_negative: 'ネガティブ郵便番号でインポートする場合：cep_start、cep_end',
        model: 'モデル',
        continue_import: 'すべてのレコードが置き換えられますが、続行してもよろしいですか？',
        cep_delivery: '配達郵便番号',
        cep_info: '配達郵便番号とそれに対応するアクションをここに示します。',
        cep_start: '郵便番号開始',
        cep_end: '郵便番号終了',
        create_cep: '配達郵便番号を作成',
        edit_cep: '配達郵便番号を編集',
        cep_delivery_negative: 'ネガティブ配達郵便番号',
        cep_info_negative: 'ネガティブ配達郵便番号とそれに対応するアクションをここに示します。',
        create_cep_negative: 'ネガティブ郵便番号を作成',
        edit_cep_negative: 'ネガティブ郵便番号を編集',
        delete_cep_negative: 'ネガティブ郵便番号を削除',
      },

      user: {
        user: 'ユーザー',
        here_are_listed_the_users_along_with_their_respective_actions:
          'ユーザーとそれに対応するアクションをここに示します',
        fill_in_the_information_below_and_click_on_the_create_button_to_save_the_changes:
          '以下の情報を入力し、「作成」ボタンをクリックして変更を保存してください',
        save_changes_edit: '以下の情報を入力し、「保存」ボタンをクリックして変更を確定してください',
        picture: '写真',
        name: '名前',
        type: 'タイプ',
        registration: '登録',
        create_user: 'ユーザーを作成',
        edit_user: 'ユーザーを編集',
        profile_picture: 'プロフィール画像',
        password: 'パスワード',
        generate_pass: 'パスワードを生成',
        access_level: 'アクセスグループ',
        select_a_access_level: 'アクセスグループを選択',
        select_type: 'タイプを選択',
        active: 'アクティブ',
        actions: 'アクション',
        discount_permission: '販売割引の権限',
        discount_value: '最大割引額（%）',
        phone: '電話番号',
      },

      groups: {
        groups: 'グループ',
        group: 'グループ',
        here_are_listed_the_groups_along_with_their_respective_actions:
          'グループとそれに対応するアクションをここに示します',
        name: '名前',
        Integrations: '統合',
        means_of_payment: '支払い方法',
        products: '製品',
        category: 'カテゴリ',
        subcategory: 'サブカテゴリ',
        indicators: 'インジケータ',
        requests: '注文',
        reports: 'レポート',
        messenger: 'メッセージング',
      },

      shifts: {
        shifts: 'シフト',
        here_are_listed_the_shifts_for_each_day_of_the_week: '各曜日のシフトをここに示します',
        monday: '月曜日',
        tuesday: '火曜日',
        wednesday: '水曜日',
        thursday: '木曜日',
        friday: '金曜日',
        saturday: '土曜日',
        sunday: '日曜日',
        start: '開始',
        end: '終了',
      },

      account: {
        account: 'アカウント',
        edit_account: 'アカウントを編集',
        registration_number: 'CNPJ',
        corporate_name: '会社名',
        customer_name: '名前',
        name_of_the_establishment: '施設の名前',
        subdomain: 'サブドメイン',
        code: 'コード',
        default_language: '標準言語',
        default_currency: '標準通貨',
        login_of_person_in_charge: 'アカウント担当者のログイン',
        name_of_person_in_charge: '担当者名',
        address: '住所',
        zip_code: '郵便番号',
        number: '番号',
        neighbourhood: '近隣',
        city: '市',
        state: '州',
        public_place: '通り',
        address_complement: '補足',
        info: 'サブドメインを変更するには、サポートに連絡してください',
      },

      terms: {
        terms: '規約',
        here_are_the_terms_of_acceptance_of_the_sales_platform:
          '販売プラットフォームの同意規約をここに示します',
        create_your_term: '規約を作成',
        term_name: '規約の名前',
        valid_until: '有効期限',
        name: '名前',
        expirated: '期限切れ',
      },

      payment_plans: {
        payment_plans: '支払いプラン',
        here_are_listed_the_payment_plans_along_with_their_respective_actions:
          '支払いプランとそれに対応するアクションをここに示します',
        create_payment_plans: '支払いプランを作成',
        fill_the_information_below_and_click_the_create_button_to_save_the_changes:
          '以下の情報を入力し、「作成」ボタンをクリックして変更を保存してください',
        erp_integration: 'ERP統合',
        integration_type: '統合タイプ',
        select_an_integration: '統合を選択',
        card_flag: 'カードブランド',
        flag: 'ブランド',
        type: 'タイプ',
        erp_code: 'ERPコード',
        card_installment: '分割払い',
        payment_plan: '支払いプラン',
        installment: '分割',
        time: '期間',
        credit: 'クレジット',
        debit: 'デビット',
      },

      indicators: {
        indicators: 'インジケータ',
        orders: '注文',
        filters: 'フィルタ',
        first: '開始',
        end: '終了',
        total_order: '合計注文数',
        revenue: '収益',
        orders_by_location: 'モダリティ別注文',
        orders_by_month: '月別注文',
        orders_by_day: '日別注文',
        orders_by_hour: '時間別注文',
        orders_by_month_sector: '月とモダリティ別注文',
        orders_by_day_sector: '日とモダリティ別注文',
        orders_by_hour_sector: '時間とモダリティ別注文',
        product: '製品',
        categories: 'カテゴリ',
        sales_by_category: 'カテゴリ別売上',
        revenue_by_category: 'カテゴリ別収益',
        average_ticket: '平均客単価',
        quantity: '数量',
        summary: '概要',
        summaryAccess: 'アクセス',
        summaryAccessGroup: '期間別のアクセスされたエリア',
        summaryTimeAccessGroup: '時間別合計',
        summaryIPAccessGroup: 'ユーザー別合計',
        summarySellerCart: '販売者によって作成されたカートの合計',
        period: '期間を選択',
        summaryTypeCust: 'コストタイプ別合計',
        summaryComposition: 'コスト構成',
        cost: 'コスト',
        customer: '顧客',
        seller_sales_by_category: '販売者によるカテゴリ別売上',
        summary_seller: '販売者の概要',
        sellers_invoice: '販売者の請求',
        comparative_sales_by_channel: 'チャネル別売上比較',
        select_view: 'ビューを選択',
        sales: '売上',
        attended_customers: 'サービス提供された顧客',
        carts: '保存されたカート',
        sales_conversion: '売上コンバージョン',
        mean_ticket: '平均客単価',
        sales_client: '顧客別売上比較/ランキング',
        sellers: '販売者',
        summary_store: '店舗の概要',
        accesses: '訪問',
        active_sellers: 'アクティブな販売者',
        revenue_store: '店舗の請求',
        revenue_group: 'グループの請求',
        comparative_sales_by_seller: '販売者別売上比較',
        comparative_sales_by_store: 'ビジネスユニットの比較',
        comparative_by_seller: '販売力 - 販売者比較',
        stores: '店舗',
        invoicing: '請求',
        active_stores: 'アクティブな店舗',
        summary_group: 'グループの概要',
        invoice_by_store: '店舗別請求',
        rank_sellers: '販売者ランキング',
        rank_stores: '店舗ランキング',
      },

      customer_list: {
        customer_list: '顧客リスト',
        listed_customers: '顧客とそれに対応するアクションをここに示します。',
        select_time: '行われた注文の期間',
        name: '名前',
        first: '開始',
        end: '終了',
        phone: '電話',
        date: '日付',
        detail: '顧客の詳細',
        total_profit: '総利益',
        total_itens: '合計項目数',
        total_orders: '合計注文数',
        order_between: '間の注文',
        order_detail: '注文の詳細',
        create: '顧客を作成',
        go_detail: '詳細を表示',
        product: '製品',
        value: '価格',
        quantity: '数量',
        total: '合計',
        edit: '顧客を編集',
      },

      smart_order: {
        smart_order: 'スマートオーダー',
        message_warning_find_variation:
          '製品のバリエーションが見つかりません。SKU/EANコードを確認してください。',
        service_classification: 'サービス分類',
        product: '製品',
        create_product: '製品を作成',
        here_are_listed_the_products_along_with_their_respective_actions:
          '製品とそれに対応するアクションをここに示します',
        name: '名前',
        code: 'コード',
        color_code: ' カラーコード',
        crop_image: '画像を切り抜き',
        use_original_image: '元の画像を使用',
        select_image_format: '画像形式を選択',
        use_selected_size: '選択したサイズを使用',
        format_640x640: '640x640（正方形）',
        format_600x900: '600x900（縦長）',
        product_data: '製品データ',
        mark: 'ブランド',
        measurement_unit: '測定単位',
        description: '説明',
        technical_specification: '技術仕様',
        from: 'から',
        characters: '文字',
        order: '順序',
        product_image: '製品画像',
        additional_images: '追加画像',
        product_groups: '製品の顧客グループ',
        categories: 'カテゴリ',
        here_are_listed_the_categories_along_with_their_respective_actions:
          'カテゴリとそれに対応するアクションをここに示します',
        image: '製品画像',
        image_variation: 'バリエーション画像',
        category: 'カテゴリ',
        category_parent: '親カテゴリ',
        category_name: 'カテゴリ名',
        category_code: 'カテゴリコード',
        perfil_image: 'プロフィール画像',

        subcategories: 'サブカテゴリ',
        subcategory: 'サブカテゴリ',
        here_are_listed_the_subcategories_along_with_their_respective_actionsc:
          'サブカテゴリとそれに対応するアクションをここに示します',
        select_category: 'カテゴリを選択',

        marks: 'ブランド',
        listened_marks: 'ブランドとそれに対応するアクションをここに示します',

        measurements_units: '測定単位',
        listened_measurement: '測定単位とそれに対応するアクションをここに示します',

        grid_products: 'グリッド',
        listened_grid: '製品グリッドとそれに対応するアクションをここに示します',
        grid_name: 'グリッド名',
        grid_code: 'コード',
        variation: 'バリエーション',
        grid: 'グリッド',
        grids: 'グリッド',

        variations: 'バリエーション',
        listened_variations: '製品のバリエーションとそれに対応するアクションをここに示します',
        modality: 'モダリティ',
        select_modality: 'モダリティを選択',
        prod: '製品',
        select_product: '製品を選択',
        no_variation: 'バリエーションなしの製品',
        variation_product: '製品のバリエーション',
        cost_price: '原価',
        sell_price: '販売価格',
        promotional_price: 'プロモーション価格',
        weight: '重量',
        height: '高さ',
        width: '幅',
        depth: '奥行き',
        availability: '製品の在庫状況は？',
        when_product_stock: '製品の在庫がなくなった場合は？',
        stock: '在庫製品の数量',
        min_stock: '最小在庫',
        price: '価格',

        catalogs: 'カタログ',
        catalog: 'カタログ',
        create_catalog: 'カタログを作成',
        edit_catalog: 'カタログを編集',
        catalog_link: 'カタログリンクをコピー',
        listened_catalogs: '製品カタログとそれに対応するアクションをここに示します。',
        validity: '有効期間',
        first: '開始',
        end: '終了',
        search_products: '製品検索',

        product_status: '製品のステータス',
        sku: 'SKU/EAN',
        status_variation: 'バリエーションのステータス',
        specification: '仕様',
        price_promotional: '割引価格',
        inventory: '在庫',
        preparation_time: '準備時間',
        service_title: 'サービスとそれに対応するアクションをここに示します。',

        initial_hour: '開始時間',
        final_hour: '終了時間',

        date_start: '開始日',
        date_end: '終了日',

        add_group: '追加項目のリスト',
        no_add: 'この製品はまだ追加項目のリストに関連付けられていません。',
        already_add: 'この製品は次の追加項目のリストに関連付けられています。',
        associate_add: '追加項目のリストに関連付ける',
        associate: '関連付ける',
        choose_add: 'この製品に関連付ける追加項目のリストを選択します。',
        no_group_add: '関連付ける利用可能な追加項目のリストはありません。',
        remove_add: '関連付けを削除',
        remove_add_text: 'この製品と追加項目のリスト「@」の関連付けを削除してもよろしいですか？',
        limit_range: '最大間隔制限に達しました',

        remove_add_soon:
          '注意！このタブはまもなく削除されます。追加項目の管理は引き続き通常どおり行えます。「基本情報」タブにアクセスし、「追加項目のグループ」セクションに移動して、この製品の追加項目を確認してください。',
        create_image_ia: 'AI画像提案',
        create_image_ia_text: '画像を生成するための製品の説明を入力します。',
        generate_images: '画像を生成',
        generate_description: '説明をパーソナライズ',
        generate_new_options: '新しいオプションを生成',
        save_image_selected: '選択した写真を保存',
        reference_image_ia: '参照画像',
        image_qtd_ia: '画像の数量',
        save_img_ia: '画像を保存',
        cancel: 'キャンセル',

        more_category: 'このカテゴリのその他の設定を表示',
        selectAll: 'すべて選択',
        alterLot: 'ロットを変更',
        edit_category:
          'カテゴリの関連付けの変更は許可されていません。新しいカテゴリを作成することをお勧めします',

        catalog_image: 'カタログ画像',
      },

      service_grid: {
        service_grid: 'サービスグリッド',
        service_grid_single: 'サービスグリッド',
        create_service_grid: 'サービスグリッドを作成',
        edit_service_grid: 'サービスグリッドを編集',
        service_grid_name: 'サービスグリッド名',
        service_grid_name_placeholder: 'サービスグリッド名',
        start_hour: '開始時間',
        start_hour_placeholder: '00:00',
        end_hour: '終了時間',
        end_hour_placeholder: '23:59',
        interval: '間隔',
        interval_placeholder: '00:15',
        interval_tooltip: '注文間の時間間隔',
        service_list: 'サービスリスト',
        service_placeholder: 'サービス',
        missing_fields: '不足しているフィールド',
        missing_fields_message: 'すべてのフィールドに入力したか確認してください！',
        grid_created: 'グリッドが登録されました',
        grid_created_message: '登録が正常に実行されました！',
        grid_updated: 'グリッドが変更されました',
        grid_updated_message: '編集が正常に実行されました！',
        error: 'エラー',
        error_create_message: 'グリッドの登録中にエラーが発生しました！',
        error_update_message: 'グリッドの変更中にエラーが発生しました！',
        fill_information_create:
          '以下の情報を入力し、「作成」ボタンをクリックして変更を保存してください',
        save_changes_edit: '以下の情報を入力し、「保存」ボタンをクリックして変更を確定してください',
        dashboard: 'ダッシュボード',
        title: 'タイトル',
        listed_grids: 'サービスグリッドとそれに対応するアクションをここに示します',
        grid_deleted: 'グリッドが削除されました',
        grid_deleted_message: '削除が正常に実行されました！',
        error_delete_message: 'グリッドの削除中にエラーが発生しました！',
        status: 'ステータス',
        grid_linked_warning: 'リンクされたグリッド',
        grid_linked_message:
          'このグリッドは {count} 件のサービスフォームにリンクされているため、削除できません。',
      },

      webapp: {
        webapp: 'Webアプリ',
        generate_qrcode: 'QRコードを生成',
        personalize: 'パーソナライズ',
        settings: '設定',
        link: 'Webアプリへのリンク',

        webapp_data: 'Webアプリのデータ',
        name: '名前',
        place: '場所',
        product_pagination: 'ページネーションの製品数',
        logo_ninegrid: 'Ninegridのロゴ',
        light: '明るい',
        dark: '暗い',
        logo_totvs: 'TOTVSのロゴ',
        use_icon_menu: 'Webアプリメニューでアイコンを使用',
        description: '説明',
        icon: 'アイコン',
        color_setting: '色の設定',
        background_webapp: 'Webアプリの背景',
        background_default_webapp: 'Webアプリのデフォルトカラー',
        background_header: 'ヘッダーの背景',
        text_header: 'ヘッダーのテキスト',
        icon_header: 'ヘッダーのアイコン',
        background_footer: 'フッターの背景',
        icon_footer: 'フッターのアイコン',
        highlight_footer: 'フッターの強調表示',
        notification_cart: 'カートの通知',
        notification_text: '通知テキスト',
        home_button: 'ホームボタン',
        text_home_button: 'ホームボタンのテキスト',
        title_bar: 'タイトルバー',
        text_title_bar: 'タイトルバーのテキスト',
        icon_title_bar: 'タイトルバーのアイコン',
        text_category: 'カテゴリのテキスト',
        webapp_button: 'Webアプリのテーマ',
        text_button: 'ボタンのテキスト',
        background_menu: 'サイドメニューの背景',
        text_menu: 'サイドメニューのテキスト',
        price_card_background: '価格カードの背景',
        price_card_font_color: '価格カードのフォント色',
        order_status: '注文ステータス',
        order_active_status: 'アクティブな注文ステータス',
        text_order_active_status: '注文ステータスのテキスト',
        info_cart: 'カートの情報',

        settings_webapp: 'Webアプリの設定',
        type_delivery: '配達制限のタイプ',
        integration: '統合',
        select_integration: '統合を選択',
        payment_method_card: '支払い方法 カード',
        payment_method_pix: '支払い方法 Pix',
        payment_method_delivery: '支払い方法 配達時',
        consent_letter: '同意書を有効化',
        product_no_stock: '在庫切れの製品の販売',
        show_subcategory: 'サブカテゴリを表示',
        show_observation: '備考を表示',
        use_category_list: 'サブカテゴリと製品をリストで表示',
        use_category_list_v2: 'カテゴリとサブカテゴリをリストで表示',
        use_product_list: '製品をリストで表示',
        remove_shadow: 'カテゴリとカタログに影を追加しない',
        remove_show_mode: '表示モードを削除',
        no_shadow: 'カテゴリに影を追加しない',
        is_order_number: 'カテゴリを並べ替え',
        order_number: '順序で',
        order_category: 'アルファベット順',
        show_layout: 'レイアウトを表示',
        image_type: '製品の画像スタイル',

        withdraw_fee: '持ち帰り手数料',
        minimum_value: '最小注文額',
        seller_checkout: 'チェックアウトのモダリティ',

        no_sales: '販売を許可しない',
        safe_mode: 'セーフモード',
        time_safe_mode: 'セーフモードのセッション時間（分）',
        limit_characteres_explanation:
          'WintorまたはProtheusとの統合がある店舗の場合、推奨される最大文字数は50文字です。',
        limit_characteres: '文字制限',

        skip_entry: 'エントリ画面をスキップ',
        payment_table: 'テーブルでの支払い',

        payment_card: 'コマンドでの支払い',

        slides_homePage: 'ホームページのハイライト画像',
        slides_initial: '初期のハイライト画像',

        slides_not_found: 'スライダー画像が見つかりませんでした',

        externalLink: '外部リンク',
        buttonType: 'ボタンのタイプ',
        ableUserLocation: '位置情報による住所検索を許可',
        ableWaiter: 'ウェイターを呼ぶオプションを無効化',
        closeAccountButton: 'アカウント閉鎖ボタンを削除',
        emitNfChef: '注文支払い後に請求書を発行しますか？（カウンター/テーブル/コマンド）',

        seller_cart_limit_time: '販売者カートの期限切れ時間（時間）',
        seller_cart_limit_time_explanation: '顧客が販売者のカートを使用できる最大時間',
        settings_webapp_aggregator: 'パーソナライズ',
        generate_qrcode_webapp_aggregator: 'QRコードを生成',
        qrcode_webapp_aggregator: 'Webアプリケーション',
        security_settings: 'セキュリティ設定',
        biometric_authentication: '生体認証',
        code_scanner: 'バーコードと QR コード リーダーを許可する',
        maximus_radius: '位置情報：許可される最大近接半径（メートル）',
        access_maximus: 'テーブルごとの最大アクセス数',
        limit_time: 'コマンドの有効期限が切れるまでのアクセス時間（分）',
        password: 'アクセスを解除するためのパスワード',
        flag_discount: '割引フラグの形式',
        color_flag_discount: 'タグの色',

        config_tags: 'タグを設定',
        promotional_tags: 'プロモーションタグ',

        pre_created: '事前登録',

        show_classification_button: 'すべてのカテゴリを表示するボタンを表示',
        show_catalog_button: 'すべてのカタログを表示するボタンを表示',
        show_catalog_name: 'カタログ名を表示',
        show_classification_name: 'カテゴリ名を表示',
        show_mark_name: '製品ブランドを表示',
        show_stock_quantity: '製品在庫を表示',
        show_promotional_tags: 'プロモーションラベルを表示',
        show_product_sku: '製品のSKUを表示',
        tag_display_groups: '製品リストにタググループを表示',
        text_free_delivery: '無料配達または持ち帰りのカスタムテキスト',
        tooltip_free_delivery:
          '入力されている場合、配達または持ち帰りが無料のときにこのテキストが表示されます。空の場合は、R$ 0,00の値が表示されます',
        place_holder_free_delivery: '例: 無料',
        no_show_grid: '製品の単一バリエーションのグリッドを省略',
        explain_show_grid:
          '単一バリエーションのグリッドを非表示にします。複数のオプションを持つグリッド（例：サイズ G; GG）は、製品選択では表示されますが、他の場所では非表示になります。',

        type_image: '画像タイプ',
        type_image_square: '正方形',
        type_image_rectangle: '長方形',

        directlink: 'ダイレクトリンク',
        infoDirectLink:
          '必須ではありません。別のページやサイトに直接送信する必要がある場合にのみ使用します。最大 350 文字',

        block_add_in_limit: '制限での追加をブロック',

        family_fonte: 'フォントファミリー',
        rounding_images: '画像の丸め',
        rounding_bars: 'バーの丸め',
        color_icons: 'アイコンの色',
        color_icons_header_footer: 'ヘッダーとフッターのアイコンの色',
        background_icon_button: 'アイコンの背景色',
        background_icon_custom: 'カスタムカラー',
        restaurant_list: 'レストランをリストで表示',
        restaurant_display_mode: 'レストランの表示モードを変更',
        icon_button_size: 'ボタンアイコンのサイズ',
        shadow_image: '画像の影',
        black_logo_nine: 'ダークナイングリッドロゴ',
        skip_loud_screen: '読み込み画面をスキップ',
        can_acesse_restaurant: 'ログインなしでカタログ（店舗/レストラン）の閲覧を許可する',
        info_acesse_restaurant:
          'このフラグを有効にすると、ユーザーはログインせずにレストランまたは店舗のメニュー/カタログにアクセスできます。決済統合が有効な場合、決済ステップの前に店舗またはレストランのWebAppで直接ログインが要求され、注文がホテルシステムのユーザーコンテキスト（プロファイル/予約）に正しく関連付けられます。',
      },

      integration: {
        integration: '統合',
        means_of_payment: '支払い方法',
        here_are_listed_the_means_of_payment_along_with_their_respective_actions:
          '支払い方法とそれに対応するアクションをここに示します',
        PDV: 'POS統合',
        listed_here_are_the_integrations_along_with_their_respective_actions:
          '統合とそれに対応するアクションをここに示します',
        integration_name: '統合名',
        type_of_integration: '統合タイプ',
        actions: 'アクション',
        search: '検索',
        example: 'ペイロードの例',

        loads: 'ロード',
        name: '名前',
        price: '価格',
        stock: '在庫',
        measurements_units: '測定単位',
        grid: 'グリッド',
        classifications: 'カテゴリ',
        products: '製品',
        status_sync: 'ステータス同期',
        marks: 'ブランド',
        orders: '注文',
        trigger_load: 'ロードをトリガー',
        first: '開始',
        end: '終了',
        load: 'ロード',
        messenger: 'メッセージング',
        others: 'その他',
        test: '統合をテストしますか',
        params_test: 'この統合のパラメータを表示',
        copy_params: 'パラメータをコピー',
        result_test: '統合テストの結果',
        success_1: '成功！統合',
        success_2: 'は成功しました。',
        result_log: '結果ログ',
        copy_result: '結果をコピー',
        search_result: '結果を検索',
        error_1: '統合',
        error_2: 'はエラーを返しました。詳細については、以下のログを確認してください。',

        success_food_1: '成功！統合',
        success_food_2: 'は成功しました。',
        error_food_1: '統合',
        error_food_2: 'はオフラインを返しました。',

        integrationPrint: '接続をテスト',
      },

      reports: {
        orders: '注文',
        order_report: '注文レポート',
        order_list: '注文リスト',
        first: '開始',
        end: '終了',
        firstTime: '開始時間',
        endTime: '終了時間',
        orders_between: '間の注文',
        order_number: '注文番号',
        date: '日付',
        consumer: '消費者',
        modality: 'モダリティ',
        total_value: '価格',
        cancel_order: '注文をキャンセル',

        products: '製品',
        quantity: '数量',
        qtt: '数量',
        product: '製品',
        value: '価格',
        total: '合計',
        order_status: '注文ステータス',
        payment_method: '支払い方法',
        billing_address: '請求先住所',
        product_value: '製品の価格',
        discount: '割引',
        order: '注文',

        listened_logs: 'ログとそれに対応するアクションをここに示します。',
        methods: '方法',
        log_details: 'ログの詳細',

        withdraw: '持ち帰り',
        delivery: '配達',
        table: 'テーブル',
        counter: 'カウンター',
        responsible_withdraw: '持ち帰りの担当者',
        responsible_delivery: '受付の担当者',
        address_withdraw: '持ち帰り先住所',
        address_delivery: '配達先住所',
        seller: '販売者',
        seller_link: '販売者リンク',
        external_code: '外部番号',
        payment: '支払い',
        internal_delivery: '内部配達',
        origin: '原点',
        historial: '注文履歴',
        approval_moment: '承認日時',
        id: '予約コード',
        pluginspace: 'ホテル',
        hotel: 'ホテルに関連付けられた注文',
        document: '予約書類',
        room: '客室コード',
        status_payment: '支払いステータス',
        authorization_code: '認証コード',
        transaction: 'トランザクションID',
        made_in: '実行日',
        send_method: '送信方法',
        send_date: '送信日',
        estimated_delivery: '配達予測',
        freight: '運賃',
        tracking_code: '追跡コード',
        website: '追跡サイトを開く',
        label: '発送ラベルを印刷',
        payment_delivery: '配達時支払い',
        payment_money: '現金支払い',
        change_money: 'お釣り',
        label_code: 'ラベル',
        label_website: 'ラベルサイトを開く',
        declaration_code: '宣言',
        declaration_website: '宣言サイトを開く',
        height: '高さ (cm)',
        width: '幅 (cm)',
        length: '長さ (cm)',
        weight: '重さ (kg)',
        send_text: '顧客が選択した発送方法：',
        success_label: '発送ラベルが正常に生成されました。',
        continue: '続行',
        confirm: '確認',
        change_multiple_status: '複数の注文のステータスを変更',
        change_status_text: '以下の注文のステータスを変更してもよろしいですか？',
        new_status: '新しいステータス',
        change_status: 'ステータスを変更',

        synkar: '自動化',
        invalid_data: '開始日と終了日を選択してください。',

        details: '詳細',
      },

      imports: {
        imports: 'インポート',
        import_image_product: '製品の画像インポート',
        import_image_category: 'カテゴリの画像インポート',
        listened_import_product: '製品の画像インポートとそれに対応するアクションをここに示します。',
        no_upload_images: '画像のアップロードを実行しない',
        first: '開始',
        end: '終了',
        total_products: '合計製品数',
        sync_products: '同期された製品',
        import_image_sku: 'バリエーションの画像インポート',
        listened_import_sku:
          'バリエーションの画像インポートとそれに対応するアクションをここに示します。',
        verify_verification: 'バリエーションの確認',
        product_code: '製品コード',
        code: 'コード',
        total_variations: '合計バリエーション数',
        sync_variations: '同期されたバリエーション',
        total_categories: '合計カテゴリ数',
        sync_categories: '同期されたカテゴリ',
        problem_title: '問題のある画像',
        images_success: '画像が正常に送信されました。',
        images_error: '画像に問題があり、送信されませんでした。',
        file: 'ファイル',
        status: 'インポートステータス',
        new_import: '新しいインポートを実行',
        import_xls: 'XLSファイルで画像をインポート',
        import_repo: 'Google DriveまたはDropboxから画像をインポート',
        steps: 'インポートのステップバイステップ',
        step_1: '1. すべての画像を公開Webサーバーに配置します。',
        step_2: '2. サーバーが公開されており、Web経由でアクセスできることを確認します。',
        step_3: '3. 空のXLSXファイルをダウンロードします。',
        step_4: '4. 画像バンクのデータで入力します。',
        step_5: '5. 入力されたファイルをアップロードします。',
        step_1_repo:
          '1. 店舗フォルダが「fotos_loja_<店舗識別子>」として作成されていることを確認します。',
        step_2_repo: '2. 店舗フォルダ内に「produtos」フォルダを作成します。',
        step_2_repo_sku: '2. 店舗フォルダ内に「variacoes」フォルダを作成します。',
        step_2_repo_category: '2. 店舗フォルダ内に「categorias」フォルダを作成します。',
        step_3_repo: '3. ファイルが「<製品コード>.<拡張子>」の形式であることを確認します。',
        step_3_repo_sku: '3. ファイルが「<sku>.<拡張子>」の形式であることを確認します。',
        step_3_repo_category:
          '3. ファイルが「<カテゴリコード>.<拡張子>」の形式であることを確認します。',
        step_4_repo: '4. 追加製品の場合は、「_<番号>」があるか確認します。',
        step_4_repo_sku:
          '4. バリエーションが画像であり、JPGまたはPNG拡張子であることを確認します。',
        step_4_repo_category: '4. カテゴリが画像であり、JPGまたはPNG拡張子であることを確認します。',
        step_5_repo: '5. 製品が画像であり、JPGまたはPNG拡張子であることを確認します。',
        download: '空のXLSXファイルをダウンロード',
        download_problems: 'レポートをエクスポート',
        upload: 'ファイルを送信',
        upload_anex: 'ファイルを添付',
        import_dropbox: 'Dropboxでインポート',
        import_drive: 'Google Driveでインポート',
        spreadsheet: 'スプレッドシート',
        gdrive: 'Google Drive',
        dropbox: 'Dropbox',
        type: 'タイプ',
        type_resize: 'リサイズタイプ',
        agroup_color: '色で写真をグループ化',
        banner_size: 'カテゴリN1をバナーとして扱う',
        select_dimensions: '寸法を選択',
        square: '640x640として扱う',
        vertical: '600x900として扱う',
      },

      sms: {
        sms: 'SMS',
        listened_sms: 'メッセージ（SMS）とそれに対応するアクションをここに示します。',
        order: '順序',
        name: '名前',
        message: 'メッセージ',
        markers: 'マーカー [pedido] と [status] はメッセージに含まれている必要があります',
        waiting: '待機中',
        opened: '未解決',
        ready: '準備完了',
        refused: '拒否されました',
        message_hotel: 'ホテルSMS',
        listened_sms_hotel: 'ここにホテルのメッセージと対応するアクションを表示します。',
        status_hotel: 'ホテルステータス',
        listened_status_hotel:
          'ここにホテルのステータスとメッセージ、および対応するアクションを表示します。',
        edit_status: 'ステータスを編集',
        edit_status_hotel: 'ホテルステータスを編集',
        notification: '通知',
        email_group_status: 'ステータス',
        email_group_service_forms: 'サービスフォーム',
        email_group_services: 'サービス',
        email_group_services_booking: 'サービス - Booking',
        send_email_simple: 'メール送信',
        status_label: 'ステータス',
        write_message_status: 'このステータス用のメッセージをここに入力してください',
        markers_hotel:
          'マーカー [pedido], [status], [cliente], [quarto], [hotel] はメッセージに含まれている必要があります',
        status_updated: 'ステータスが更新されました',
        status_update_success: '更新が正常に完了しました！',
        status_update_error_title: 'エラー',
        status_update_error: 'ステータスの更新中にエラーが発生しました！',
      },

      multichannel: {
        multichannel: 'マルチチャネル',
        listened_multichannel: 'マルチチャネル設定とそれに対応するアクションをここに示します。',
      },

      feed: {
        content: 'コンテンツ',
        title: 'タイトル',
        fill_in_the_information_below_and_click_on_the_create_button_to_save_the_changes:
          '以下の情報を入力し、「作成」ボタンをクリックして変更を保存してください',
      },
      feedCategory: {
        feedCategory: 'コンテンツのカテゴリ',
      },

      structured_content: {},

      queue: {
        index: '待機列',
        menage: '管理',
        config: '待機列の設定',
        able: '待機列を許可',
        link: '待機列のリンク：',
        limit_people: '最大人数',
        limit_people_text: '待機列の制限',
        limit_time: 'アラートを表示する時間制限',
        limit_time_text: '遅延と見なす最大時間（分）',
        image_title: '画像定義',
        image_text:
          '待機列システムは2つの画像を表示します。レストランの写真をアップロードするか、以下の標準写真を選択してください。送信された写真は350x250ピクセルに調整されます。',
        image: '画像',
        position: '位置',
        time: '待機時間',
        people: '人',
        cancel: 'キャンセル',
        cancel_text: 'この人を待機列から削除してもよろしいですか？',
        cancel_button: '削除',
        confirm: '確認',
        confirm_text: '予約者の到着を確認してもよろしいですか？',
        confirm_button: '到着を確認',
        empty: '現在待機リストはありません',
        confirm_all: 'すべて確認',
        cancel_all: 'すべてキャンセル',
        observation: '備考',
        use_terms: '同意規約を有効化',
        total_people: 'グループあたりの合計人数',
        total_people_text: 'グループあたりの待機列の制限',
        all: 'すべて',
        in_queue: '列に並んでいます',
        preferential: '優先',
        confirmed: '確認済み',
        removed: '拒否されました',
        show: '表示',
        show_text: '過去 @ 時間',
        yes: 'はい',
        no: 'いいえ',
        add: '顧客を列に追加',
        use_location: '位置情報を許可しますか？',
        use_menu: 'メニューを使用しますか？',
        use_ninegrid_menu: 'Ninegridメニューを使用しますか？',
        external_menu_link: 'メニューリンクを入力',
        edit: '列の顧客を編集',
      },
      booking: {
        index: '予約',
        config: '予約の設定',
        able: '予約を許可',
        link: '予約のリンク：',
        image_title: '画像定義',
        image_text:
          '予約システムは2つの画像を表示します。レストランの写真をアップロードするか、以下の標準写真を選択してください。送信された写真は350x250ピクセルに調整されます。',
        image: '画像',
        days_week: '曜日',
        booking_day: 'この日の予約を許可しますか？',
        booking_day_text: '以下に予約が可能な時間を定義してください。',
        booking_day_subtext:
          '時間を選択すると、1時間のウィンドウが定義されます。例：19:00を選択すると、人々は19:00から20:00の間に予約できます。',
        max_people: '予約あたりの最大人数',
        max_people_text: '予約を行うことができるグループの最大人数です',
        expiry_time: '予約が期限切れになるまでの最大時間',
        expiry_time_text: '予約者の到着を待つ最大時間（分）',
        day_confirm: '当日の確認が必要',
        day_confirm_text: 'ユーザーは選択した日に予約を確認する必要があります',
        payment_confirm: '予約での前払いが必要',
        value_payment_confirm: '前払いの価格',
        week: '週',
        month: '月',
        year: '年',
        use_terms: '同意規約を有効化',
        empty: '現在予約はありません',
        use_time: '期間による予約を許可',
        time: '予約の期間（HH:mm）',
        time_cancel: '予約のキャンセル期限（HH:mm）',
        time_change: '予約の変更期限（HH:mm）',
        use_change: '予約時間の変更を許可',
      },
      booking_day: {
        booking: '本日の予約',
        date: '日付',
        people: '人',
        expiry: '期限切れまで',
        cancel_title: 'キャンセル',
        cancel_subtitle: 'この予約をキャンセルしてもよろしいですか？',
        cancel_button: '予約をキャンセル',
        confirm_title: '確認',
        confirm_subtitle: '予約者の到着を確認してもよろしいですか？',
        confirm_button: '到着を確認',
        accessibility_needs: 'アクセシビリティのニーズ',
        accessibility_elderly: '高齢者サポート',
        accessibility_wheelchair: '車椅子利用者',
        accessibility_physical: '身体障害',
        filter_accessibility: 'アクセシビリティでフィルター',
        all_accessibility: 'すべてのニーズ',
      },
      booking_report: {
        report: 'レポート',
        search: '予約検索',
        time: '期間を選択',
        date_start: '開始日',
        date_end: '終了日',
        confirm: '確認',
        noShow: 'ノーショー',
        confirmed: '確認済み予約',
        canceled: 'キャンセルされた予約',
        open: '未解決',
        map: '予約マップ',
        booking: '予約',
        accessibility_stats: 'アクセシビリティ統計',
        accessibility_total: 'ニーズのある総数',
        accessibility_percentage: 'パーセンテージ',
      },
      booking_report_management: {
        management: '予約管理',
        search: '予約検索',
        phone: '電話',
        date_start: '開始日',
        date_end: '終了日',
        today: '今日',
        tomorrow: '明日',
        calendar: 'カレンダー',
        see_all: 'すべて表示',
        people: '人',
        noShow: 'ノーショー',
        confirmed: '確認済み',
        canceled: 'キャンセル済み',
        open: '未解決',
        search_text: '電話検索または日付選択による結果',
      },
      environment: {
        map: '環境マップ',
        environment: '環境',
        index: '環境',
        name: '環境名',
        tables: 'テーブルの数',
        seats_available: '利用可能な席の合計',
        actions: 'アクション',
      },
      week_day: {
        sun: '日',
        mon: '月',
        tue: '火',
        wed: '水',
        thur: '木',
        fri: '金',
        sat: '土',
      },
      week_day_full: {
        sun: '日曜日',
        mon: '月曜日',
        tue: '火曜日',
        wed: '水曜日',
        thur: '木曜日',
        fri: '金曜日',
        sat: '土曜日',
      },
      checkout: {
        title: '顧客データ',
        here_are_listed_the_modalities_along_with_their_respective_actions:
          '顧客作成に必要なフィールドをここに示します。',
        active_mandatory: '必須フィールド',
        active_visibility: '表示可能なフィールド',
      },

      liveShop: {
        liveShop: 'ライブコマース',
        liveShop_list: 'ライブコマースイベントとそれに対応するアクションをここに示します。',
        create: 'ライブコマースを作成',
        edit: 'ライブコマースを編集',
        dateInit: '開始',
        hourInit: '開始時間',
        dateEnd: '終了',
        hourEnd: '終了時間',
        status: 'ステータス',
        initDate: '開始日時',
        fimDate: '終了日時',
        name: '名前',
        variations: '製品のバリエーション',
        search_products_Attentions:
          '返される製品とバリエーションは、ステータスが有効化され、価格、在庫、画像を持っている必要があります',
        alert_delete: 'ライブが開始されたか終了した後は削除できません！',
        alert_Edit: 'ライブが開始されたか終了した後は編集できません！',
        delete: 'ライブコマースを削除',
      },

      logs: {
        //PagSeguro
        pagseguroPaymentCodePhone: 'Pagseguroの電話コードエラー',
        pagseguroPaymentErrorCountry: 'Pagseguroの国コードエラー',
        pagseguroPaymentErrorEmail: 'Pagseguroのメールエラー',
        authenticatePagseguro: 'Pagseguro認証',
        pagseguroPayment: 'Pagseguro支払い',
        pagseguroPaymentCatch: 'Pagseguro支払い',
        pagseguroPaymentResponse: 'Pagseguroの支払いの応答',
        pagseguroPaymentTransactions: 'Pagseguroの支払いのトランザクション',
        pagseguroReturnPayment: 'Pagseguroの支払いの返却',
        paymentPixPagseguro: 'Pagseguro Pix支払い',

        pagseguroPaymentGateway: 'Pagseguroの支払いゲートウェイ',
        getAuthPagseguroEmailSpace: 'メールによるPagseguroの認証',
        getOneApplicationClientId: 'Pagseguroクライアントのアプリケーションを取得',
        createAuthPagseguro: 'Pagseguro認証を作成',
        generatePublicKeyPagseguro: 'Pagseguro公開鍵を生成',
        updateCodeRedirectApplication: 'Pagseguroアプリケーションコードの更新',
        deleteAuthPagseguroByEmail: 'Pagseguro認証を削除',
        createPluginconfig: 'プラグインの設定',

        //Totvs 支払い HUB
        refundTotvs: 'Totvs経由で払い戻し',
        refundPayCard: 'Totvs経由でカードによる払い戻し',
        paymentTotvs: 'Totvs経由で支払い',
        paymentPixTotvs: 'Totvs経由でPix支払い',

        //カード構造
        sendUnregisteredCardBrands: 'ブランドが見つかりません',
        cardStructure: 'カード構造',
        cardStructureInvalidPlugin: 'ゲートウェイのプラグインが無効です',
        cardStructureGatewayError: 'ゲートウェイのカードエラー',
        cardStructureData: 'カードデータ',
        cardStructureError: 'カードデータエラー',
        cardStructureDecrypt: 'カードの復号化',
        cardStructureFields: 'カードフィールド',
        refundCard: 'カードの払い戻し',

        //ステータス
        analysisSatusOrder: '分析のための注文ステータス',
        statusPayPix: 'Pixステータス',

        //不正防止
        analyseAntifraud: '不正防止分析',
        dataClearSale: 'ClearSaleデータ',
        statusAnalysis: '分析のステータス',

        //在庫
        addSkuInventory: '在庫に追加',
        subtractSku: '在庫から削除',
        viewCargoHistory: 'ロード履歴を表示',
        viewCargoHistoryBySku: 'SKU別のロード履歴を表示',

        // 注文-Pedido
        sendOrderIn: '注文の送信',
        cancelOrder: '注文をキャンセル',
        sendOrder: '注文を送信',
        sendOrderRefund: '注文の払い戻し',
        sendOrderError: '注文の送信中にエラーが発生しました',
        sendOrderResultRefund: '注文の払い戻し結果',
        sendOrderResultData: '注文の送信結果',
        sendOrderAntifrud: '注文送信時の不正防止',
        sendOrderPaymentStruct: '注文の支払い構造',

        sendOrderDescryptor: '注文の復号化',
        sendOrderStatus: '注文ステータス',
        sendOrderConfigNotFound: '注文送信設定が見つかりません',
        sendOrderMandatoryCustomer: '注文の顧客',
        sendOrderMandatory: '注文の必須構造',
        sendOrderResultGateway: 'ゲートウェイへの送信結果',
        OrderFashionService: 'ファッション注文サービス',
        OrderFashionServiceError: 'ファッション注文サービスエラー',
        cartOrderLive: 'ライブ注文のカート',
        cartOrderLiveError: 'ライブ注文のカートエラー',
        sendOrderErrorGeral: '注文エラー',
        sendPushNotification: 'プッシュ通知を送信',

        //プレオーダー
        preOrderStatusPix: 'Pix経由のプレオーダーステータス',
        processQueuePreOrder: 'プレオーダーキュー処理',
        getAllPreOrderBySpace: 'Pluginspaceごとにすべてのプレオーダーを取得',
        sendPreOrder: 'プレオーダーの送信',
        makeOrderTransparent: '注文確認',
        statusPreOrder: 'プレオーダーのPixステータスの更新',
        preOrderStatusCanceledPix: 'Pix経由のプレオーダーをキャンセル',

        //Totvs Wintor
        buildOrderTotvsWinthor: '注文を作成',
        sendOrderWinthor: '注文をTotvsに送信',
        sendCustomerOrderWinthor: '顧客をTotvsに送信',

        //Totvs Varejo
        buildOrderTotvsVarejo: '注文を作成',
        setConfimTicket: 'チケットの確認',
        SyncOrderLive: '注文同期',
        ObterProdutos: '製品を取得',
        taskPrice: '価格ロード',
        calculationPromotion: 'プロモーション計算',
        PayloadCalcPromotion: 'プロモーション計算ペイロード',

        //Totvs Moda
        changeStatus: 'ステータス変更',
        sendOrderFashion: '注文をTotvsに送信',
        sendCustomerFashion: '顧客をTotvsに送信',
        searchPersonTotvsByCPF: 'Totvs顧客検索',
        sendErrorCustomerFashion: '顧客をファッションに送信中にエラーが発生しました',
        buildCustomerTotvsFashion: 'Totvsで顧客を作成',
        ResumeSnyOrderFashion: 'ファッションとの同期概要',
        changeStatusFashion: 'ステータスを変更',
        buildOrderTotvsFashion: 'ファッション注文を作成',

        //Totvs Food
        updateStatusOrderFoodIntegration: 'ステータス変更',
        buildOrderTotvsFood: '注文を作成',
        changeStatusOrderFood: 'ステータス変更',
        sendOrderTotvsFood: '注文をTotvsに送信',
        confirmMenu: 'メニューを確認済み',
        getMenu: 'Totvsメニューを取得',

        //Totvs Live
        sendCustomerLive: 'ライブ顧客の送信',
        sendOrderLive: 'ライブ注文の送信',

        //Synkar
        updateStatusOrderSynkar: 'Synkar注文の更新',
        sendingOrderMessageSynkar: 'Synkarメッセージングの送信',
        responseOrderMessageSynkar: 'Synkarメッセージングの応答',
        sendingOrderSynkar: 'Synkarの送信',
        responseOrderSynkar: 'Synkarの応答',

        //SDS
        sdsGetOrders: 'SDS注文を取得',
        sdsOrderIn: 'SDS注文の送信',
        sdsOrderInResult: '注文をSDSに送信',
        sdsSyncCardapio: 'メニューとSDSの同期',
        'sendOrderfood-sdsOrderIn': 'SDS注文の送信中にエラーが発生しました',

        //S3
        createRoute: 'S3ルートを作成',
        getStatusfiftythree: 'ルート53のステータス',
        updateDistribution: '配信を更新',
        deleteRoute: 'S3ルートを削除',
        deleteDistribution: '配信を削除',

        //Erede
        refundErede: 'Eredeの払い戻し',
        paymentErede: 'Eredeの支払い',

        //Cielo
        refundCielo: 'Cieloの払い戻し',
        paymentCielo: 'Cieloの支払い',

        //Pagseguro
        refundPagseguro: 'Pagseguroの払い戻し',
        getApplicationPagseguro: 'Pagseguroアプリケーションゲートウェイ',

        //オフライン支払い
        paymentOffline: '配達時支払い',

        //一般
        chargeSyncOrderErro: 'ステータス同期エラー',
        chargeSyncOrder: 'ステータス同期',
        chargeProductLive: 'ライブ製品の同期',
        chargeBalanceLive: 'ライブ在庫の同期',
        chargePriceLive: 'ライブ価格の同期',
        chargeProductLiveErro: 'ライブ製品の同期エラー',
        chargeBalanceLiveErro: 'ライブ在庫の同期エラー',
        chargePriceLiveErro: 'ライブ価格の同期エラー',

        chargeProduct: '製品の同期',
        chargeBalance: '在庫の同期',
        chargePrice: '価格の同期',
        chargeProductErro: '製品の同期エラー',
        chargeBalanceErro: '在庫の同期エラー',
        chargePriceErro: '価格の同期エラー',

        taskBalanceIntegration: '在庫ロードの統合',
        taskBalanceCharge: '在庫ロードが開始されました',
        SnyOrder: '注文ステータスの同期',
        syncronyzePriceInteration: '価格ロード',
        syncronyzePrice: '価格同期',
        chargeClassification: 'カテゴリとサブカテゴリのロード',
        chargeGrid: 'グリッドロード',
        chargeGridItens: 'グリッドロード項目',
        chargeMeasure: '測定単位ロード',
        deleteAllProducts: 'すべての製品を削除',

        chargeGridToken: 'グリッドロードのトークン',
        classificationChargeToken: '分類ロードのトークン',
        syncronyzeBalanceToken: '在庫同期のトークン',
        syncronyzePriceToken: '価格同期のトークン',
        chargeMeasureToken: '測定単位ロードのトークン',
        taskClassificationBySpace: '分類ロード',
        syncStatusOrderPayload: '注文ステータス同期ペイロード',
        syncStatusOrder: '注文ステータス同期',
        syncStatusOrderToken: '注文ステータス同期トークン',
        syncronyzeBalancePayload: '在庫同期ペイロード',
        syncronyzeBalance: '在庫同期',
        taskBalanceChargeBySpace: '在庫ロード',
        syncronyzePricePayload: '価格同期ペイロード',
        priceSkuVariationItens: 'バリエーション項目の価格',
        configSyncOrderBySpace: '注文同期設定',
        configSyncOrder: '注文同期設定',
        taskGridChargeBySpace: 'グリッドロード',
        productChargeInternal: '製品ロード',
        taskChargeProductBySpace: '製品ロード',
        skuLocationVariation: '場所別のバリエーション同期',
        stockSkuVariation: 'バリエーション同期',
        taskPriceChargeBySpace: 'Pluginspaceごとの価格ロード',

        automaticChargeBalance: '自動在庫同期',
        automaticChargePrice: '自動価格同期',
        automaticChargeClassification: '自動分類同期',
        automaticTaskGridCharge: '自動グリッド同期',
        automaticTaskMeassure: '自動測定単位同期',
        automaticSnyOrder: '自動注文ステータス同期',
        chargeMeasureItens: '測定単位ロード項目',
        searchMeasurementAll: '測定単位ロード',
        taskGridCharge: 'グリッドロード',
        taskMeassure: '測定単位ロード',

        getCredential: 'トークンを取得',
        LoadPricePerList: '価格ロード',
        processPriceList: '価格リスト処理',
        updateProductKit: '製品の更新',
        UpdateProductSingle: '製品の更新',
        updateProductStatus: '製品ステータスの更新',
        taskBalanceIntegrationLink: '在庫統合リンク',
        taskPriceIntegrationLink: '価格統合リンク',
        taskProductIntegrationLink: '製品統合リンク',
        token: 'トークンの取得',
        automaticChargeProduct: '製品の自動ロード',

        //Ninegrid割引
        calculateDiscount: 'Ninegridでの割引計算',
        sendDiscountNinegrid: 'Ninegrid割引',

        //顧客カート
        updateCustomerCartStatus: '顧客カートの更新',

        //顧客
        createCustomer: '顧客の作成',
        validCodeCustomer: '顧客の検証コード',

        //clearSale
        statusAnalisis: 'ステータスの分析',
        antifraudValidation: '不正防止の検証',
        clearSale: 'ClearSale保証',
        searchOrderStatusClearSale: 'ClearSaleステータス検索',

        printLabelFrenet: 'Frenetラベル',
        changeStatusFrenet: 'Frenetステータス変更',
        callWaiter: 'ウェイターを呼ぶ',
        paymentTable: 'テーブルでの支払い',

        // シェフの請求書生成
        generateNfOrderFood: '注文の請求書を生成',
        getNotaFiscalChef: 'シェフの請求書を取得',
        finishOrderFood: '請求書前のチェック',

        // シェフの注文エラーログ
        buildCardData: 'コマンドのデータ作成中にエラーが発生しました',
        buildTableData: 'テーブルのデータ作成中にエラーが発生しました',
        buildTablePaymentData: 'テーブル支払いのデータ作成中にエラーが発生しました',
        buildCounterData: 'カウンターのデータ作成中にエラーが発生しました',
        buildDeliveryData: '配達/持ち帰りのデータ作成中にエラーが発生しました',

        generateCustomerWholeSalerByCSV: 'CSVで卸売顧客を生成',

        validateStockWholeSaleCart: '注文アラート',
        validateWholeSaleCart: '注文アラート',

        chargeImageService: '画像ロードサービス',

        webhookNisRedis: '店舗のRedisのクリーンアップ',

        /*メール送信 */
        sendEmailWelcome: 'ウェルカムメールを送信',
        sendEmailOrderNotification: '注文のメール通知を送信',
        sendEmailAccountNotification: 'アカウントのメール通知を送信',
        createCustomerLogin: '顧客ログイン作成メールを送信',
      },

      copy: {
        definition: 'Pluginspaceの定義',
        origin: '元のPluginspaceを選択',
        destination: '目的のPluginspaceを選択',
        configurations: 'コピーの設定',
        store: '店舗設定',
        deliveryFee: '配送料',
        shifts: 'シフト',
        paymentPlans: '支払いプラン',
        clientData: '顧客データ',
        account: 'アカウント設定',
        groups: 'グループ',
        terms: '規約',
        webapp: 'Webアプリ',
        webappConfig: '設定',
        webappPersonalize: 'パーソナライズ',
        whatsappweb: 'WhatsApp Web',
        whatsappwebConfig: '設定',
        whatsappwebPersonalize: 'パーソナライズ',
        integrations: '統合',
        integrationPayment: '支払い方法',
        integrationPdv: 'POS',
        integrationMessaging: 'メッセージング',
        integrationOthers: 'その他',
        button: 'Pluginspaceをコピー',
      },

      payment: {
        methods: '支払い方法',
        method: '支払い形式',
        gateway: '支払いゲートウェイ',
        card: 'クレジットカード',
        debit: 'デビットカード',
        food: '食事バウチャー',
        pix: 'Pix',
        others: 'その他',
        pay_money: '現金',
        config: '設定',
        add: '支払い方法を設定',
        back: '支払いゲートウェイに戻る',
        basic_settings: '基本設定',
        modalities: 'この支払い方法が使用されるモダリティ',
        add_payment: '支払い形式を追加',
        code_erp: 'ERPコード',
        installments: '分割回数',
        edit_payment: '支払い形式を編集',
        delete: '支払い形式を削除',
        money: '現金支払い',
        max_installments: '最大分割回数は？',
        min_value_installments: '分割の最小金額は？',
        confirm: '削除を確認',
        delete_payment: '支払い形式を削除しますか',
        change: 'この交換を実行しますか？',
        inative: 'この支払い形式を非アクティブ化しますか？',
        inative_change: 'この支払い形式をアクティブ化して古いものを非アクティブ化しますか？',
        motive: '理由を教えてください',
        /* 割引に使用 */
        config_descount_payment: '支払い方法ごとの割引設定',

        able_discount_pix: 'Pix支払い割引を有効化',
        able_discount_card: 'カード支払い割引を有効化',
        able_discount: '支払い割引を有効化',

        discount_percentage: '割引率',
        discount_monetary: '金額割引',
        discount_value: '割引額',
      },

      icon: {
        title: 'アイコン',
        subtitle: 'ライブラリのすべてのアイコンをここに示します',
      },
      freight: {
        title: '発送モダリティ',
        map: 'マップ',
        map_text: '注文の配達時支払いオプション',
        range: '半径',
        range_text: '注文の配達時支払いオプション',
        cep: '郵便番号リスト',
        cep_text: '注文の配達時支払いオプション',
        config: '設定',
        delivery: '自社配達',
        delivery_text: '3つのカスタマイズ可能な配達オプションがあります：',
        frenet: 'Frenet',
        frenet_text: 'さまざまな運送業者と発送手段を使用した、完全な運賃管理。',
        frenet_text_2: 'この統合を有効にするには、Frenetのプランが必要です。',
        site: '公式サイトを見る',
        coming_soon: '近日公開...',
      },
      frenet: {
        title: 'Frenetとの統合',
        back: '配達手段に戻る',
        integration: '統合',
        config: '設定',
        dimensions: 'センチメートル単位の基本的な配達寸法',
        height: '高さ',
        width: '幅',
        length: '長さ',
        value: '製品の申告価格',
        use: '使用',
        dont_use: '使用しない',
        price: '簡略化された見積もりを使用しますか？',
        yes: 'はい',
        no: 'いいえ',
        branchCode: 'Jadlogの投函場所',
        no_balance: 'Frenetに残高がありません',
        value_balance: 'Frenetに @ の残高があります',
        print_balance:
          'この注文の発送ラベルを印刷するには、Frenetアカウントにチャージする必要があります。',
        click_balance: '下のボタンをクリックして、別のタブでFrenetにアクセスしてください。',
        open_balance: 'Frenetアカウントを開く',
        valid_token: '無効なトークン',
        declared_value: '申告価格は、運送業者による保険の場合に使用されます。',
        getToken:
          'Frenetでトークンを見つけるには、アクセスキーセクションにアクセスし、「TOKEN」フィールドの値をコピーする必要があります。',
        weight_frenet: '標準重量（kg）',
        height_frenet: '標準の高さ（cm）',
        width_frenet: '標準の幅（cm）',
        depth_frenet: '標準の奥行き（cm）',
        alert_title: '運賃計算の参照寸法',
        alert_warning: '注意！',
        alert_description:
          'これらの寸法は、登録された体積のない製品の運賃を計算するために使用されます。',
        alert_wrong_values: '不正確な値は以下を生成する可能性があります：',
        alert_overpriced: '過剰請求された運賃（顧客を遠ざける）。',
        alert_additional_costs: '追加コスト（運送業者が後で値を調整する場合）。',
        alert_recommendation: '各製品の実際の体積を登録することをお勧めします。',
        alert_reference: '参照寸法：',
        alert_small_products: '小さな製品',
        alert_small_examples: '（例：アクセサリー、コスチュームジュエリー、ケーブル）',
        alert_small_weight: '重さ: 0.1–0.3 kg',
        alert_small_dimensions: '寸法: 10 × 10 × 5 cm',
        alert_medium_products: '中程度の製品',
        alert_medium_examples: '（例：衣料品、本、小型電子機器）',
        alert_medium_weight: '重さ: 0.5–2 kg',
        alert_medium_dimensions: '寸法: 25 × 20 × 10 cm',
        alert_large_products: '大きな製品',
        alert_large_examples: '（例：家電製品、かさばる箱）',
        alert_large_weight: '重さ: 5–20 kg以上',
        alert_large_dimensions: '寸法: 50 × 40 × 30 cm以上',
      },
      chat: {
        you: 'あなた',
        now: '今すぐ送信',
        send: '送信',
        type_message: 'メッセージを送信...',
        initial_message: 'Ninegrid AIチャットへようこそ',
        error_message:
          'メッセージへの回答が見つかりませんでした。より具体的にするか、後でもう一度試してください。',
        tip_language: '日本語で返信してください。',
        title_config: '人工知能の設定',
        config: '人工知能を設定',
        fit: '人工知能のトレーニング',
        fit_header: '質問とそれに対応する作成された回答をここに示します',
        add_question: '質問を追加',
        edit_question: '質問を編集',
        delete_question: '以下の質問を削除してもよろしいですか？',
        question: '質問',
        answer: '回答',
        date: '日付',
        actions: 'アクション',
        active: 'アクティブ',
        delete: '削除',
        sync: 'AIを同期',
        upload: 'ファイルのアップロード',
        about: '概要',
        chatia: 'チャット',
        about_title: 'Ninegrid AIについて',
        about_description_title: '説明',
        about_description:
          'Ninegrid AIは、サポートタスクを支援するために設計されたインテリジェントな仮想アシスタントです。',
        about_support_title: 'サポート',
        about_support_description:
          'ご質問やサポートが必要な場合は、当社のサポートチームがお手伝いいたします。',
        about_support_contact_1: 'サポートに連絡するには、メールでご連絡いただくか',
        about_support_contact_2: 'または、ポータルでチケットを開いてください：',
        about_features_title: '機能',
        tips: '質問を作成するためのヒント',
        about_tips_1: '明確で客観的な質問を使用して、より良い回答を得てください。',
        about_tips_2: 'スラングや複雑な専門用語は避けてください。',
        about_tips_3: '回答に満足できない場合は、質問を言い換えてみてください。',
        about_tips_4: 'Ninegrid AIは相互作用から学習するため、使用すればするほど改善されます。',
        feature_1: '自然言語での会話',
        feature_2: '音声コマンドのサポート',
        feature_3: '回答の音声合成',
        feature_4: '直感的で応答性の高いインターフェース',
        about_manuals: 'マニュアル',
        about_manuals_description:
          'Ninegrid環境の使用方法の詳細については、マニュアルを確認してください。',
        about_faq: 'よくある質問',
        about_faq_description:
          '一般的な疑問を解消するために、最もよくある質問とその回答を確認してください。',
        about_version_title: 'システム情報',
        version: 'バージョン',
        last_update: '最終更新日',
        rights_reserved: '全著作権所有',
        access_here: 'こちらにアクセス',
        our_faq: 'よくある質問を見る',
        or: 'または',
        and: 'と',
      },
      sumary_access: {
        cart: 'カート',
        seller: '販売者ログイン',
        category: 'カテゴリ',
        pdv: '製品の詳細',
        subcategory: 'サブカテゴリ',
        product: '製品リスト',
        home: '初期画面',
        'search-order': '注文',
        'store-info': '店舗情報',
        customer: '顧客登録',
        receipt: '支払い領収書',
        order: '支払い',
        card: 'カード支払い',
        'order-qrcode': '顧客Pix支払い',
        'success-order': '購入成功',
        'filter/pdv': 'フィルタの結果',
        filter: 'フィルタの選択',
        'seller-qrcode': '支払いリンク',
        'vendor-order ': '販売者のカートの照会',
        'finalize-order': '購入概要',
      },
      optional: {
        optionals: '追加項目',
        list: '追加項目のリスト',
        name: '名前',
        used: '使用場所',
        config: '設定',
        link: '製品を関連付ける',
        products_optional: 'リストに関連付けられた製品',
        edit: '追加項目のリストを編集',
        type: '選択タイプ',
        max: '最大',
        mandatory: '必須',
        order: '順序',
        code: 'コード',
        qtd: '最大数量',
        price: '価格',
        include: '追加項目を含める',
        create: '追加項目のリストを作成',
        description: 'Webアプリの説明',
        emptyProduct: 'この追加項目を使用している製品はありません',
      },

      coupons: {
        title: 'クーポン',
        report: 'クーポンレポート',
        titleCreate: 'クーポンを作成',
        titleUpdate: 'クーポンを編集',
        subTitle: 'クーポンとそれに対応するアクションをここに示します。',
        create: 'クーポンを作成',
        edit: 'クーポンを編集',
        delete: 'クーポンを削除',

        //入力変数
        name: 'クーポン名',
        name_helper: '最大 15 文字',
        description: '説明',
        description_placeholder: '最大 200 文字を受け付ける必要があります',
        seller: '販売者',
        catalog: 'カタログ',
        discountValue: '割引額',
        discountPercentage: '割引率',
        type: 'タイプ',
        dateInit: '開始日',
        dateEnd: '終了日',
        quantitative: '使用回数',
        typeOptions: {
          all: 'すべてのタイプ',
          classification: '分類',
          product: '製品',
          individuality: '個別',
          exclusive: '専用',
          quantitative: '数量的',
          periodical: '定期的',
          cupomday: 'クーポンの日',
        },
        filters: 'フィルター',
        status: 'ステータス',
        selectStatuses: 'ステータスを選択してください',
        actions: {
          filter: 'フィルター',
          export: 'エクスポート',
        },
        quick: {
          today: '今日',
          week: '今週',
          month: '今月',
          lastMonth: '先月',
          year: '今年',
        },
        stats: {
          title: '一般統計',
          totalCoupons: 'クーポン合計',
          activeCoupons: '有効なクーポン',
          totalUsages: '使用合計',
          totalDiscount: '割引合計',
        },
        distribution: {
          title: 'タイプ別分布',
        },
        monthlyUsage: {
          title: '月間使用量',
        },
        series: {
          usageCount: '使用回数',
          numberOfUses: '使用回数',
          discountValue: '割引額',
        },
        table: {
          details: 'クーポンの詳細',
        },
        statusLabels: {
          true: '有効',
          false: '無効',
        },
      },

      order_print: {
        title: '印刷を確認する前に注文情報を確認してください',
        print_text: '印刷',
        information:
          'QZ Trayは接続を確立するためのアクセス許可を要求します。「許可」をクリックして印刷に進んでください。',
        order_details: '注文の詳細',
        client: '顧客',
        payment: '支払い',
        created: '作成日',
        print: '注文を印刷',
        print_confirm:
          'この注文を印刷してもよろしいですか？続行する前に、プリンタが正しく接続され、設定されていることを確認してください',
      },

      whatsappweb: {
        title: 'WhatsApp Web',
        subtitle: 'WhatsAppの設定とそれに対応するアクションをここに示します。',
        titleCreate: 'WhatsAppを同期',
        titleDelete: 'WhatsAppの同期を削除',
        create: 'WhatsAppを同期',
        delete: 'WhatsAppセッションを削除',
        active: 'アクティブ',
        welcome: 'NinegridのWhatsApp Web',
        describe_whatsappweb: 'ここでは、WhatsApp Webを店舗の携帯電話とリンクできます！',
        config: 'WhatsAppを設定するには',
        step1: '携帯電話でWhatsAppを開きます。',
        step2: 'Androidの場合は「その他のオプション」⋮、iPhoneの場合は「設定」⚙️をタップします。',
        step3: '「リンクされたデバイス」をタップし、次に「デバイスをリンク」をタップします。',
        step4: '携帯電話をこの画面に向けてQRコードをスキャンします。',
      },
      fileManagement: {
        title: 'ファイルマネージャー',
        subtitle: 'ファイルとそれに対応するアクションをここに示します。',
        create: 'ファイルを作成',
        edit: 'ファイルを編集',
        delete: 'ファイルを削除',
        download: 'ファイルをダウンロード',
        upload: 'ファイルを送信',
        file: 'ファイル',
        file_name: 'ファイル名',
        file_item: '項目',
        file_itens: '項目',
        file_type: 'ファイルの種類',
        file_size: 'ファイルサイズ',
        file_date: '作成日',
        file_actions: 'アクション',
        file_folder: 'フォルダ',
        file_new_folder: '新しいフォルダ',
        file_folder_name: 'フォルダ名',
        file_last_modified: '最終更新日',
        file_description: 'ファイルの説明',
        file_description_placeholder: 'ファイルの説明',
        file_description_helper: '最大 200 文字',
        file_name_placeholder: 'ファイル名',
        file_name_helper: '最大 15 文字',
        file_page_showing: '表示中',
        file_not_found: 'ファイルが見つかりませんでした',
        file_uploading: 'ファイルを読み込み中',
        file_upload: 'ファイルをロード',
        file_changing: 'ファイルを変更中',
        file_Loading: 'ファイルを読み込み中',
        file_update: '更新',
        file_sync_knowledge_base: 'ナレッジベースを同期',
        file_history_sync: '同期履歴',
        scanned: 'スキャン済み',
        indexed: 'インデックス付け済み',
        modified: '変更済み',
        completed: '完了',
        deleted: '削除済み',
        failed: '失敗',
        available: '利用可能',
        last_update: '最終更新日',
        status: 'ステータス',
        status_job: 'タスクのステータス',
        data_source: 'データソース',
        knowledge_base: 'ナレッジベース',
        history_sync: '同期履歴',
        chart_scanned_doc: 'スキャンされたドキュメント',
        chart_indexed_doc: 'インデックス付けされたドキュメント',
        chart_modified_doc: '変更されたドキュメント',
        chart_deleted_doc: '削除されたドキュメント',
        chart_failed_doc: '失敗したドキュメント',
        chart_docs_processed: '処理されたドキュメント',
        chart_docs_total: 'ドキュメントの合計',
        total_jobs_processed: '処理されたタスクの合計',
        jobs_info: 'タスクに関する情報',
        observation_table_jobs_phase:
          '処理されたジョブの表には、各データソースの最新の5つのジョブが表示されます。',
      },
      service_requests: {
        title: 'サービスフォーム',
        subtitle: 'サービスリクエストフォームを管理',
        create: 'サービスフォームを作成',
        edit: 'サービスフォームを編集',
        delete: 'サービスフォームを削除',
        create_form: 'フォームを作成',
        edit_form: 'フォームを編集',
        delete_form: 'フォームを削除',
        form_title: 'タイトル',
        form_icon: 'アイコン',
        form_status: 'ステータス',
        form_description: '説明',
        form_components: 'コンポーネント',
        form_grids: 'グリッド',
        priority_label: '優先度',
        priority_low: '低',
        priority_normal: '通常',
        priority_high: '高',
        priority_critical: '緊急',
        choose_icon: '選択',
        add_component: '追加',
        sections: 'セクション',
        empty_message: '「追加」をクリックしてコンポーネントを挿入し、ドラッグして並べ替えます。',
        success_created: 'サービスフォームが正常に作成されました。',
        success_updated: 'サービスフォームが正常に更新されました。',
        success_deleted: 'サービスフォームが正常に削除されました。',
        error_create: 'サービスフォームの作成中にエラーが発生しました。',
        error_update: 'サービスフォームの更新中にエラーが発生しました。',
        error_delete: 'サービスフォームの削除中にエラーが発生しました。',
        error_load: '読み込み中にエラーが発生しました！',
        validation_title: 'セッションのタイトルを入力してください',
        validation_icon: 'セッションのアイコンを選択してください',
        validation_components: '保存する前に少なくとも1つのコンポーネントを追加してください',
        placeholder_title: '例：清掃',
        icon_selected: '選択されたアイコン（SVG）',
        icon_none: 'アイコンが選択されていません',
        visual_instructions:
          'セッションを視覚的に組み立てます。ドラッグして並べ替えます。フィールドは視覚的なもののみです（非対話型）。',
        component: 'コンポーネント',
        components_plural: 'コンポーネント',
        grid: 'グリッド',
        grids_plural: 'グリッド',
        grid_services: 'サービスグリッド',
        grid_services_title: 'サービスグリッドを選択',
        grid_services_search: 'グリッドを検索',
        grid_services_label: 'グリッド',
        grid_services_selected: '選択されたグリッド',
        grid_services_error: 'ホテルのグリッドの検索中にエラーが発生しました',
        add_component_modal: 'コンポーネントを追加',
        validation_grids_required: 'グリッドは必須です',
        validation_grids_text:
          'すべての選択コンポーネントには、少なくとも1つのサービスグリッドが選択されている必要があります。',
        actions: 'アクション',
        breadcrumb_dashboard: 'ダッシュボード',
        breadcrumb_essential_services: '必須サービス',
        // UIエレメント
        drag_title: 'ドラッグ',
        drag_action: 'ドラッグ',
        remove_title: '削除',
        remove_aria_label: 'ブロックを削除',
        max_quantity_title: '最大数量：',
        max_prefix: '最大：',
        description_label: '説明',
        sections_label: 'セクション',
        // モーダルタイトルとアクション
        select_icon_title: '選択',
        no_icons_available: '利用可能なアイコンはありません…',
        search_placeholder: '検索するテキストを入力...',
        grid_services_selected_label: '選択済み：',
        no_grid_found: 'グリッドが見つかりません',
        no_grid_available: '利用可能なグリッドはありません',
        grid_status_active: 'アクティブ',
        grid_status_inactive: '非アクティブ',
        grid_item_name_placeholder: '名前（例: リラックスマッサージ）',
        grid_item_value_placeholder: '価格（例: 50.00）',
        cancel_button: 'キャンセル',
        save_button: '保存',
        confirm_button: '確認',
        // 数量モーダル
        max_quantity_modal_title: '最大数量を定義',
        max_quantity_label: '最大数量',
        max_quantity_placeholder: '最大数量を入力',
        max_quantity_helper: 'このフィールドで選択できる項目の最大数を定義します。',
        // パンくずリスト
        breadcrumb_create: '作成',
        breadcrumb_edit: '編集',
        // フォームコンポーネント
        sample_service_1: 'サービス 1',
        sample_service_2: 'サービス 2',
        sample_hygiene: '衛生',
        sample_drinks: '飲み物',
        room_number_label: '客室番号',
        select_placeholder: '選択...',
        date_label: '日付',
        hour_label: '時間',
        quantity_label: '数量',
        between_placeholder: '間',
        and_placeholder: 'と',
        select_list_label: '選択（リスト）',
        select_item_placeholder: '項目を選択',
        select_checkbox_label: '選択（チェックボックス）',
        // Visibility
        visible_to_label: '表示対象',
        visible_to_employees: '従業員',
        visible_to_customers: '顧客',
        visible_to_both: '両方',
        select_category_placeholder: 'カテゴリを選択',
        select_quantity_label: '選択（数量）',
        qty_label: '数量',
        // カタログタイトル
        catalog_room_number: '客室番号',
        catalog_date: '日付',
        catalog_hour: '時間',
        catalog_date_hour: '日付 + 時間',
        catalog_select_list: '選択（リスト）',
        catalog_select_list_quantity: '選択（リスト）+ 数量',
        catalog_select_checkbox: '選択（チェックボックス）',
        catalog_select_count: '選択（数量）',
        catalog_quantity: '数量',
      },
      base_modal: {
        attention_title: '注意！',
        unsaved_changes_text: '行われた変更は失われます。終了してもよろしいですか？',
        confirm_button: 'はい',
        cancel_button: 'いいえ',
      },
      summarize_ia: {
        title: 'AI使用状況の概要',
        subtitle: 'AIの概要情報がここにリストされています。',
        create: 'AI概要を作成',
        edit: 'AI概要を編集',
        delete: 'AI概要を削除',
        summarize: '要約',
      },
      hospitality: {
        add_room: '客室を追加',
        create_multiples: '複数を作成',
        add_activity: 'アクティビティを追加',
        add_experience: '体験を追加',
        experiences: '体験',
        experience_type: '体験のタイプ',
        experience_duration: '期間',
        experience_price: '価格',
        experience_rating: '評価',
        experience_includes: '含まれるもの',
        create_experience: '体験を作成',
        edit_experience: '体験を編集',
        experience_created: '体験が正常に作成されました！',
        experience_updated: '体験が正常に更新されました！',
        experience_deleted: '体験が正常に削除されました！',
      },
      hospitality_content: {
        page_title: 'ボタン',
        page_subtitle: 'セクションのボタンがここに一覧表示されます。',
        add_button: 'ボタンを追加',
        filters: {
          sections: 'セクション',
        },
        table: {
          headers: {
            title: 'タイトル',
            order: '順序',
            formTitle: 'フォームのタイトル',
            type: 'タイプ',
            visibility: '可視性',
            actions: 'アクション',
          },
        },
        tabs: {
          buttons: 'ボタン',
          native_buttons: 'ネイティブボタン',
        },
        actions: {
          edit: 'ボタンを編集',
          delete: 'ボタンを削除',
          delete_confirm: 'このボタンを削除してもよろしいですか？',
        },
        type_labels: {
          service_form: 'サービスフォーム',
          feedback: 'ご意見',
          service: 'サービス',
          information: '情報',
          activities_leisure: 'アクティビティとレジャー',
          bars_restaurants: 'バーとレストラン',
          schedule: '予約',
          experience: '体験',
          booking: 'スケジュール',
          check_in: 'チェックイン',
          check_out: 'チェックアウト',
          tours: 'ツアー',
          page_dynamic: '動的ページ',
        },
        no_category: 'カテゴリなし',
        messages: {
          filter_error_title: 'エラー',
          filter_error_text: 'セクションのフィルタリング中にエラーが発生しました',
          load_error_title: '読み込みエラー',
          load_error_text: 'セクションの読み込みに失敗しました！',
          section_not_found_title: 'エラー',
          section_not_found_text: 'セクションが見つかりません！',
          deleted_title: 'セクションが削除されました',
          deleted_text: '削除は正常に実行されました！',
          delete_error: 'セクションの削除中にエラーが発生しました！',
          visibility_updated_title: '可視性が更新されました',
          visibility_updated_text: 'ボタンの可視性が正常に更新されました！',
          visibility_error_title: '更新エラー',
          visibility_error_text: 'ボタンの可視性の更新中にエラーが発生しました！',
          form: 'フォーム',
          page: 'ページ',
        },
        create_modal: {
          modal_title: 'コンテンツを追加',
          alert_title: 'セクションとコンテンツの選択',
          alert_subtitle: '対応するセクションとコンテンツを選択してください。',
          label_section: 'セクション',
          label_content: 'コンテンツ',
          placeholder_select: '選択',
          placeholder_select_section: 'セクションを選択',
          placeholder_select_content: 'コンテンツを選択',
          order_label: '順序',
          selection_summary: '選択の概要:',
          badge_section: 'セクション',
          badge_content: 'コンテンツ',
          select_form_label: 'フォームを選択 (roomService)',
          tips_title: 'ヒント',
          tips: {
            item1: 'セクションは複数のコンテンツを持つことができます',
            item2: 'コンテンツは複数のセクションに属することができます',
            item3: '順序はリスト内の位置を定義します',
          },
          buttons: {
            cancel: 'キャンセル',
            create: '作成',
          },
          swal: {
            missing_field_title: '不足しているフィールド',
            missing_section: '続行するにはセクションを選択してください',
            missing_content: '続行するにはコンテンツを選択してください',
            invalid_field_title: '無効なフィールド',
            invalid_order: '順序は正の数またはゼロである必要があります',
            created_title: 'コンテンツが登録されました',
            created_text: '登録は正常に完了しました！',
            create_error: 'コンテンツの登録中にエラーが発生しました！',
          },
        },
        edit_modal: {
          modal_title: 'コンテンツを編集',
          alert_title: 'コンテンツの編集',
          alert_subtitle:
            '必要に応じてセクションと順序を変更してください。現在のコンテンツは変更できません。',
          label_section: 'セクション',
          label_content: 'コンテンツ',
          placeholder_select: '選択',
          placeholder_select_section: 'セクションを選択',
          placeholder_select_content: 'コンテンツを選択',
          order_label: '順序',
          selection_summary: '選択の概要:',
          badge_section: 'セクション',
          badge_content: 'コンテンツ',
          tips_title: 'ヒント',
          tips: {
            item1: 'セクションのみ変更できます',
            item2: '順序はリスト内の位置を定義します',
          },
          buttons: {
            cancel: 'キャンセル',
            save: '保存',
          },
          swal: {
            missing_field_title: '不足しているフィールド',
            missing_section: '続行するにはセクションを選択してください',
            missing_content: '続行するにはコンテンツを選択してください',
            invalid_field_title: '無効なフィールド',
            invalid_order: '順序は正の数またはゼロである必要があります',
            updated_title: 'コンテンツが更新されました',
            updated_text: '更新は正常に完了しました！',
            update_error: 'コンテンツの更新中にエラーが発生しました！',
          },
        },
        category: {
          page_title: 'セクション',
          page_subtitle: 'ここでは、コンテンツのセクションとそれぞれの操作が一覧表示されています。',
          add_button: '追加',
          breadcrumbs: {
            dashboard: 'ダッシュボード',
            categories: 'カテゴリ',
          },
          table: {
            headers: {
              section: 'セクション',
              order: '順序',
              status: 'ステータス',
              actions: 'アクション',
            },
          },
          options: {
            edit_category: 'カテゴリを編集',
            delete_section: 'セクションを削除',
            delete_confirm: 'セクションを削除',
          },
          swal: {
            deleted_title: 'セクションが削除されました',
            deleted_text: '削除は正常に完了しました！',
            delete_error: 'セクションの削除中にエラーが発生しました！',
          },
          create: {
            missing_fields_title: '不足しているフィールド',
            missing_fields_text: 'すべてのフィールドを正しく入力したか確認してください！',
            created_title: 'カテゴリが登録されました',
            created_text: '登録は正常に完了しました！',
            create_error: 'カテゴリの登録中にエラーが発生しました！',
          },
          update: {
            missing_fields_title: '不足しているフィールド',
            missing_fields_text: 'すべてのフィールドを正しく入力したか確認してください！',
            updated_title: 'カテゴリが更新されました',
            updated_text: '編集は正常に完了しました！',
            update_error: 'カテゴリの更新中にエラーが発生しました！',
          },
          type: {
            default: '標準',
            banner: 'フィーチャーバナー',
          },
        },
      },
      clean_safe: {
        title: '清潔と安全',
        subtitle: '安全対策、清掃プロトコル、および認定を管理します',
        security_measures: '安全対策',
        cleaning_protocols: '清掃プロトコル',
        certifications: '認定',
        add_security_measure: '対策を追加',
        add_cleaning_protocol: 'プロトコルを追加',
        add_certification: '認定を追加',
        add_new_security_measure: '新しい対策を追加',
        add_new_cleaning_protocol: '新しいプロトコルを追加',
        add_new_certification: '新しい認定を追加',
        security_measure: '安全対策',
        cleaning_protocol: '清掃プロトコル',
        certification: '認定',
        icon: 'アイコン',
        choose_icon: 'アイコンを選択',
        title_field: 'タイトル',
        description: '説明',
        status: 'ステータス',
        active: 'アクティブ',
        inactive: '非アクティブ',
        remove: '削除',
        save: '保存',
        required_title: 'タイトルは必須です',
        required_icon: 'アイコンは必須です',
        required_fields: '必須フィールド',
        required_fields_message: 'すべての必須フィールドに入力してください。',
        confirmation: '確認',
        delete_security_measure_confirm: 'この安全対策を削除してもよろしいですか？',
        delete_cleaning_protocol_confirm: 'この清掃プロトコルを削除してもよろしいですか？',
        delete_certification_confirm: 'この認定を削除してもよろしいですか？',
        yes: 'はい',
        no: 'いいえ',
        error: 'エラー',
        error_delete: '項目の削除中にエラーが発生しました。',
        success: '成功',
        success_save: '衛生および安全データが正常に保存されました！',
        error_save: 'データの保存中にエラーが発生しました。',
        empty_security_measures: 'まだ安全対策が追加されていません。',
        empty_cleaning_protocols: 'まだ清掃プロトコルが追加されていません。',
        empty_certifications: 'まだ認定が追加されていません。',
        empty_start_message: '「追加」をクリックして開始します。',
        placeholder_security_title: '安全対策のタイトルを入力',
        placeholder_protocol_title: 'プロトコルのタイトルを入力',
        placeholder_certification_title: '認定のタイトルを入力',
        placeholder_security_description: '簡単な説明を入力（最大 100 文字）',
        placeholder_protocol_description: '清掃プロトコルの詳細な説明を入力',
      },
      orders_room_service: {
        title: '客室注文',
        subtitle: 'ホテルのサービスリクエストの管理',

        // フィルタ
        status: 'ステータス',
        start_date: '開始日',
        end_date: '終了日',
        reservation_id: '予約コード',
        post_id: '投稿ID',
        service_type: 'サービスタイプ',
        search: '検索',
        clear_filters: 'フィルタをクリア',

        // ステータス
        status_pending: '保留中',
        status_confirmed: '確認済み',
        status_in_progress: '進行中',
        status_cancelled: 'キャンセル済み',
        status_concluded: '完了',
        status_completed: '完了',

        // フィルタオプション
        all_status: 'すべてのステータス',
        all_types: 'すべてのタイプ',
        service_forms: 'サービスフォーム',
        services: 'サービス',

        // テーブルヘッダー
        service: 'サービス',
        room: '客室',
        price: '価格',
        people_qty: '人数',
        reservation: '予約',
        date: '日付',
        time: '時間',
        priority: '優先度',
        created_at: '作成日',
        actions: 'アクション',

        // ツールチップアクション
        view_details: '詳細を表示',
        change_status: 'ステータスを変更',

        // 詳細モーダル
        order_details: '注文の詳細',
        close: '閉じる',
        loading_details: '注文の詳細を読み込み中...',
        loading: '読み込み中...',

        // 注文情報
        order: '注文',
        room_service: 'ルームサービス',
        location: '場所',
        room_number: '客室番号',
        scheduled_date: '予定日',
        no_time: '時間なし',
        reservation_id_label: '予約コード',

        // 顧客情報
        customer_info: '顧客情報',
        full_name: '氏名',
        email: 'Eメール',
        phone: '電話',

        // リクエストの詳細
        request_summary: 'リクエストの概要',
        service_details: 'サービスの詳細',
        request_details: 'リクエストの詳細',
        no_items_selected: '項目が選択されていません',
        not_informed: '未通知',
        units: '単位',

        // 技術情報
        technical_info: '技術情報',
        post: '投稿',
        booking_type: '予約タイプ',
        hotel_info: 'ホテル情報',
        hotel_name: 'ホテル名',
        subdomain: 'サブドメイン',
        type: 'タイプ',
        service_form: 'サービスフォーム',
        last_update: '最終更新日',
        additional_notes: '追加の備考',

        // ステータス変更モーダル
        change_status_title: 'ステータスを変更',
        current_status: '現在のステータス',
        new_status: '新しいステータス',
        select_status: 'ステータスを選択',

        // プレースホルダー
        select_status_placeholder: 'ステータスを選択',
        select_service_type_placeholder: 'サービスタイプを選択',
        start_date_placeholder: '開始日',
        end_date_placeholder: '終了日',
        reservation_id_placeholder: '予約IDを入力',
        post_id_placeholder: '投稿IDを入力',
        new_status_placeholder: '新しいステータスを選択',

        // エラーメッセージと成功メッセージ
        error: 'エラー',
        success: '成功',
        warning: '注意',
        error_loading_orders: '注文の読み込み中にエラーが発生しました！',
        error_loading_details: '注文の詳細の読み込み中にエラーが発生しました！',
        error_changing_status: '注文ステータスの変更中にエラーが発生しました！',
        success_status_changed: 'ステータスが正常に変更されました！',
        select_status_warning: 'ステータスを選択してください。',

        // 顧客レビュー
        customer_review: '顧客レビュー',
        rating: '評価',
        review_comment: 'コメント',
      },
      s3Analytics: {
        title: 'S3アナリティクス',
        startDate: '開始日',
        endDate: '終了日',
        pluginspaceId: 'Pluginspace ID',
        pluginspaceIdPlaceholder: 'Pluginspace IDを入力',
        method: 'メソッド',
        methodPlaceholder: 'メソッドを入力（GET、POSTなど）',
        loadData: 'データをロード',
        generateAIAnalysis: 'AI分析を生成',
        chatWithAI: 'AIと会話',
        showRanking: 'ランキングを表示',
        analyzeWithAI: 'AIで分析',
        close: '閉じる',
        totalRequests: 'リクエストの合計',
        totalCost: '総コスト',
        averageCostPerRequest: 'リクエストあたりの平均コスト',
        consumptionByPluginspace: 'Pluginspaceごとの消費量',
        consumptionByMethod: 'メソッドごとの消費量',
        consumptionByDate: '日付ごとの消費量',
        costAnalysis: 'コスト分析',
        aiAnalysis: 'AI分析',
        chatMessage: 'データに関する質問を入力してください...',
        speakAnalysis: '分析を聞く',
        filterData: 'データをフィルタ',
        noDataFound: '選択したフィルタのデータが見つかりませんでした',
        errorLoadingData: 'データの読み込み中にエラーが発生しました',
        errorGeneratingAnalysis: 'AI分析の生成中にエラーが発生しました',
        analysisGenerated: '分析が正常に生成されました！',
        dataLoaded: 'データが正常にロードされました！',
        rankingData: 'ランキングデータ',
        aiChatResponse: 'AIの応答',
        s3Analytics: 'S3アナリティクス',
        filters: 'フィルタ',
        totalConsumption: '総消費量',
        totalRecords: 'レコードの合計',
        error: 'エラー',
        fetchError: 'S3データの取得中にエラーが発生しました',
        aiAnalysisError: 'AI分析の生成中にエラーが発生しました',
        aiChatError: 'AIとの会話中にエラーが発生しました',
        askQuestion: 'データに関する質問を入力してください...',
        ask: '尋ねる',
        cancel: 'キャンセル',
        ok: 'OK',
        aiResponse: 'AIの応答',
        aiAnalysisTitle: 'AI分析',
        account: 'アカウント',
        pluginspace: '店舗',
        uniquePluginspaces: '一意の店舗',
        methodDistribution: 'メソッドごとの分布',
        timeAnalysis: '時間分析',
        dataTable: 'データテーブル',
        showingFirst10: '最初の10件を表示',
        of: 'の',
        records: 'レコード',
        consumption: '消費量',
        cost: 'コスト',
        date: '日付',
        allMethods: 'すべてのメソッド',
        exportData: 'データをエクスポート',
      },
      hospitality_store: {
        establishment: '施設',
        select_establishment: '選択...',
        link: 'リンク',
        status: 'ステータス',
        payment_integrated: '統合支払い',
        order: '順序',
        store_image: '店舗の画像',
        store_image_hint: '店舗を代表する画像を選択します',
        description: '説明',
        cnpj: 'CNPJ',
        code: 'コード',
        store_id_placeholder: '店舗ID',
        type: 'タイプ',
        store_type_placeholder: '施設のタイプ',
        no_store_found: '施設が見つかりませんでした。',
        edit_store: '施設を編集',
        edit_store_subtitle: '施設のデータを編集します。',
      },
      stores_pages: {
        title: '施設',
        subtitle: 'ホテルの施設とそれに対応するアクションをここに示します。',
        create: '施設を作成',
        no_results: '施設が見つかりませんでした。',
        table: {
          code: 'コード',
          image: '画像',
          name: '店舗',
          cnpj: 'CNPJ',
          vinculation: '連携',
          vinculation_default: 'デフォルト',
          vinculation_dynamic: '動的',
          type: 'タイプ',
          order: '順序',
          status: 'ステータス',
          status_active: 'アクティブ',
          status_inactive: '非アクティブ',
          payment_integrated: '統合支払い',
          actions: 'アクション',
        },
        actions: {
          edit: '施設を編集',
          delete_confirm: '削除してもよろしいですか？',
          delete: '施設を削除',
        },
        delete_success: '施設が正常に削除されました。',
        delete_error: '施設の削除中にエラーが発生しました。もう一度お試しください。',
        success: '成功！',
        error: 'エラー！',
      },
      stores_pages_create: {
        title: '施設を作成',
        subtitle: 'ホテル用に新しい施設を作成します。',
        form: {
          establishment: '施設',
          select_placeholder: '選択...',
          link: 'リンク',
          link_placeholder: 'https://webapp.ninegrid.com.br/...',
          status: 'ステータス',
          status_options: {active: 'アクティブ', inactive: '非アクティブ'},
          payment_integrated: '統合支払い',
          payment_options: {active: 'アクティブ', inactive: '非アクティブ'},
          order: '順序',
          image_label: '施設の画像',
          image_smalltext: '施設を代表する画像を選択します',
          description: '説明',
          info_title: '施設の情報',
          cnpj: 'CNPJ',
          code: 'コード',
          type: 'タイプ',
          vinculation_label: '連携タイプ',
          vinculation_options: {default: 'デフォルト', dynamic: '動的'},
          empty_message: '施設が見つかりませんでした。',
        },
        placeholders: {
          order: '0',
          cnpj: '00.000.000/0000-00',
          store_id: '店舗ID',
        },
        console_messages: {
          image_upload_error: '画像アップロードエラー',
        },
        messages: {
          warning_title: '注意',
          select_store_warning: '保存する前に有効な施設を選択してください。',
          error_saving: '施設の保存中にエラーが発生しました。もう一度お試しください。',
          success_saved: '施設が正常に保存されました。',
        },
      },
      feedback_reviews: {
        title: '調査と満足度のレビュー',
        subtitle: 'フィードバックフォームからのすべての評価と回答を表示および管理します',
        breadcrumb_feedback: '満足度フィードバック',
        error: 'エラー',
        success: '成功',
        loading: '読み込み中...',
        loading_details: 'レビューの詳細を読み込み中...',
        close: '閉じる',
        error_loading_reviews: 'レビューの読み込み中にエラーが発生しました',
        error_loading_details: 'レビューの詳細の読み込み中にエラーが発生しました',
        error_changing_status: 'レビューのステータス変更中にエラーが発生しました',
        success_status_changed: 'ステータスが正常に変更されました',
        confirm_status_change: 'ステータス変更を確認',
        confirm_status_change_text: 'このレビューのステータスを変更してもよろしいですか？',

        // ステータス
        status_pending: '保留中',
        status_approved: '承認済み',
        status_rejected: '却下済み',

        anonymous_active: 'アクティブ',
        anonymous_inactive: '非アクティブ',

        // フィルター
        filters: {
          feedback_form: 'フォーム',
          status: 'ステータス',
          anonymous: '匿名',
          select_anonymous_placeholder: 'すべて',
          rating: '評価',
          reservation_id: '予約ID',
          start_date: '開始日',
          end_date: '終了日',
          date: '日付',
          all_forms: 'すべてのフォーム',
          all_status: 'すべてのステータス',
          all_ratings: 'すべての評価',
          select_form_placeholder: 'フォームを選択',
          select_status_placeholder: 'ステータスを選択',
          select_rating_placeholder: '評価を選択',
          reservation_id_placeholder: '予約IDを入力',
          start_date_placeholder: '開始日を選択',
          end_date_placeholder: '終了日を選択',
          filter_button: '絞り込む',
          clear_filters: 'フィルターをクリア',
        },

        // テーブル
        table: {
          feedback_form: 'フォーム',
          customer: '顧客',
          room: '部屋',
          reservation: '予約',
          rating: '評価',
          status: 'ステータス',
          date: '日付',
          time: '時間',
          actions: 'アクション',
        },

        // アクション
        actions: {
          view_details: '詳細を見る',
          approve: '承認',
          reject: '却下',
        },

        // レビューの詳細
        review_details: 'レビューの詳細',
        room: '部屋',
        reservation: '予約',
        feedback_form: 'フォーム',
        responses: '回答',
        technical_info: '技術情報',
        created_at: '作成日',
        updated_at: '更新日',
        review_id: 'レビューID',
        plugin_space_id: 'プラグインスペースID',
        anonymous_response: '匿名回答',
        no_reservation_linked: 'この回答は特定の予約にリンクされていません',
        no_detailed_responses: 'このレビューには詳細な回答がありません',
        anonymous_label: '匿名',
        email_anonymous: 'メールは利用できません（匿名の回答）',
        email_not_informed: 'メールが入力されていません',
        response_title: 'タイトル',
        no_rating_provided: '評価が提供されていません',
        no_items_selected: '選択された項目はありません',
        no_option_selected: 'オプションが選択されていません',
        no_answer_provided: '回答が提供されていません',
        form_label: 'フォーム：',
        client_not_identified: '顧客が特定されていません',
        types: {
          title: 'タイトル',
          text: 'テキスト',
          textarea: 'テキストエリア',
          stars: '評価（星）',
          checkbox: 'チェックボックス',
          radio: 'ラジオ',
          select: '選択（リスト）',
          number: '数値',
          date: '日付',
          time: '時間',
          image: '画像',
          link: 'リンク',
        },
      },
      stores_pages_edit: {
        title: '施設を編集',
        subtitle: '施設のデータを編集します。',
        form: {
          establishment: '施設',
          select_placeholder: '選択...',
          link: 'リンク',
          link_placeholder: 'https://webapp.ninegrid.com.br/...',
          status: 'ステータス',
          status_options: {active: 'アクティブ', inactive: '非アクティブ'},
          payment_integrated: '統合支払い',
          payment_options: {active: 'アクティブ', inactive: '非アクティブ'},
          order: '順序',
          image_label: '施設の画像',
          image_smalltext: '施設を代表する画像を選択します',
          description: '説明',
          info_title: '施設の情報',
          cnpj: 'CNPJ',
          code: 'コード',
          type: 'タイプ',
          vinculation_label: '連携タイプ',
          vinculation_options: {default: 'デフォルト', dynamic: '動的'},
          empty_message: '施設が見つかりませんでした。',
        },
        placeholders: {
          order: '0',
          cnpj: '00.000.000/0000-00',
          store_id: '店舗ID',
        },
        console_messages: {
          image_upload_error: '画像アップロードエラー',
          image_remove_error: '保存時に画像を削除中にエラーが発生しました',
        },
        messages: {
          success_updated: '施設が正常に更新されました。',
          error_updating: '施設の更新中にエラーが発生しました。もう一度お試しください。',
          payment_change_warning_title: '注意',
          payment_change_warning_text:
            'この変更により、チェックアウト時に進行中の予約の価格が変更される可能性があります。',
          payment_confirm: 'はい、続行',
          cancel: 'キャンセル',
        },
      },
      hospitality_section: {
        index: {
          page_title: '投稿ページ',
          page_subtitle:
            'ここには、コンテンツ投稿ページとそれぞれのアクションが一覧表示されています。',
          add_button: '投稿ページを追加',
          filters: {
            sections: '投稿ページ',
          },
          table: {
            headers: {
              title: 'タイトル',
              order: '順序',
              formTitle: 'フォームタイトル',
              type: 'タイプ',
              actions: 'アクション',
            },
          },
          actions: {
            edit: '投稿ページを編集',
            delete: '投稿ページを削除',
          },
        },
        create: {
          page_title: '投稿ページを作成',
          page_subtitle: 'ホテル用の新しいコンテンツ投稿ページを作成します。',
          add_button: '投稿ページを追加',
          filters: {
            sections: 'セクション',
          },
        },
        edit: {
          page_title: '投稿ページを編集',
          page_subtitle: 'コンテンツ投稿ページのデータを編集します。',
        },
        // セクションの動的翻訳
        types: {
          category: 'カテゴリ',
          content: 'コンテンツ',
          simple: 'シンプル',
          form: 'フォーム',
          page: 'レストランと店舗',
        },
        status: {
          active: 'アクティブ',
          inactive: '非アクティブ',
        },
        actions: {
          create: '作成',
          edit: '編集',
          delete: '削除',
          save: '保存',
          cancel: 'キャンセル',
          update: '更新',
          remove_icon: 'アイコンを削除',
          select_icon: 'アイコンを選択',
        },
        fields: {
          title: 'ボタンのタイトル',
          type: '投稿ページのタイプ',
          category: 'カテゴリ',
          order: '順序',
          status: 'ステータス',
          icon: 'アイコン',
          icon_selected: '選択されたアイコン',
          icon_not_selected: 'アイコンが選択されていません',
          icon_description: '投稿ページのサイドリストからアイコンを選択してください',
          icon_change_description:
            '投稿ページのサイドリストから別のアイコンを選択するか、現在のアイコンを削除してください',
        },
        placeholders: {
          title: 'ボタンのタイトルを入力してください',
          type: 'タイプを選択',
          category: 'カテゴリを選択',
          order: '0',
          search_icon: 'アイコンを検索...',
          all_categories: 'すべてのカテゴリ',
        },
        warnings: {
          stores:
            '動的（Dynamic）タイプの店舗が見つかりませんでした。\n続行するには、設定 → 店舗と施設 に移動して、動的タイプの店舗を設定してください。',
        },
        messages: {
          validation: {
            title_required: 'タイトルは必須です！',
            category_required: 'カテゴリを選択してください！',
            icon_required: 'アイコンを選択してください！',
          },
          success: {
            created: '投稿ページが正常に作成されました！',
            updated: '投稿ページが正常に更新されました！',
            deleted: '投稿ページが正常に削除されました！',
          },
          error: {
            create: '投稿ページの作成に失敗しました！',
            update: '投稿ページの更新に失敗しました！',
            delete: '投稿ページの削除に失敗しました！',
            load: '投稿ページのデータの読み込みに失敗しました！',
          },
          confirm: {
            delete_title: 'よろしいですか？',
            delete_text: 'このアクションは元に戻すことができません！',
            delete_confirm: 'はい、削除します',
            delete_cancel: 'キャンセル',
          },
          delete: {
            deleted_title: 'ページの削除',
            deleted_text: '削除が成功しました！',
            error_title: 'ページの削除中にエラーが発生しました！',
            error_text: 'ページの削除中にエラーが発生しました。もう一度お試しください。',
          },
        },
      },
      hospitality_classification_post: {
        index: {
          page_title: '投稿カテゴリ',
          page_subtitle: 'ここには、投稿カテゴリとそれぞれのアクションが一覧表示されています。',
          add_button: '投稿カテゴリを追加',
          filter_all: 'すべてのカテゴリ',
          table: {
            headers: {
              title: 'タイトル',
              image: '画像',
              summary: '要約',
              status: 'ステータス',
              classification: '分類',
              code: 'コード',
              actions: 'アクション',
            },
            actions: {
              edit: '投稿カテゴリを編集',
              delete: '投稿カテゴリを削除',
            },
          },
        },
        create: {
          page_title: '投稿カテゴリを作成',
          page_subtitle: 'ホテル用の新しい投稿カテゴリを作成します。',
          add_button: '投稿カテゴリを追加',
          success: {
            created_title: '投稿カテゴリが作成されました',
            created_text: '登録が正常に完了しました！',
          },
          error: {
            created_title: '投稿カテゴリの作成エラー！',
            created_text: 'カテゴリの作成中にエラーが発生しました。もう一度お試しください。',
          },
        },
        edit: {
          page_title: '投稿カテゴリを編集',
          page_subtitle: '投稿カテゴリのデータを編集します。',
          error: {
            created_title: '投稿カテゴリの編集エラー！',
            created_text: 'カテゴリの編集中にエラーが発生しました。もう一度お試しください。',
          },
          success: {
            created_title: '投稿カテゴリが編集されました',
            created_text: '登録が正常に完了しました！',
          },
        },
      },
      hospitality_post: {
        posts: '投稿',
        index: {
          page_title: '投稿',
          page_subtitle: 'ここにはホテルの投稿とそれぞれのアクションが一覧表示されています。',
          add_button: '投稿を追加',
          filter_all: '全て',
          filter: 'カテゴリ',
          table: {
            headers: {
              title: 'タイトル',
              image: '画像',
              summary: '概要',
              order: '順序',
              status: 'ステータス',
              classification: '分類',
              actions: 'アクション',
            },
            actions: {
              edit: '投稿を編集',
              delete: '投稿を削除',
            },
          },
        },
        create: {
          page_title: '投稿を作成',
          page_subtitle: 'ホテル用の新しい投稿を作成します。',
          success: {
            created_title: '投稿が作成されました',
            created_text: '登録が正常に完了しました！',
          },
          error: {
            created_title: '投稿の作成エラー！',
            created_text: '投稿の作成中にエラーが発生しました。もう一度お試しください。',
          },
        },
        edit: {
          page_title: '投稿を編集',
          page_subtitle: '投稿データを編集します。',
          success: {
            created_title: '投稿が編集されました',
            created_text: '登録が正常に完了しました！',
          },
          error: {
            created_title: '投稿の編集エラー！',
            created_text: '投稿の編集中にエラーが発生しました。もう一度お試しください。',
          },
        },
        form_validate: {
          title_required: 'タイトルは必須です！',
          summary_required: '概要は必須です！',
          classification_required: '分類は必須です！',
          content_required: 'コンテンツは必須です！',
          fields_missing: 'すべてのフィールドを入力したか確認してください！',
        },
      },
      hospitality_post_page: {
        types: {
          simple: 'シンプル',
          section: 'セクション',
          form: 'フォーム',
          category: 'カテゴリ',
        },
        index: {
          page_title: '投稿ページ',
          page_subtitle:
            'ここにはコンテンツ投稿ページとそれぞれのアクションが一覧表示されています。',
          add_button: '投稿ページを追加',
          edit_button: '投稿ページを編集',
          delete_button: '投稿ページを削除',
        },
        create: {
          page_title: '投稿ページを作成',
          page_subtitle: 'ホテル用の新しいコンテンツ投稿ページを作成します。',
          form: {
            title: '投稿ページタイトル',
            type: '投稿ページタイプ',
            status: 'ステータス',
          },
          icon: {
            icon: 'SVGアイコン',
            lib: 'SVGアイコンライブラリ',
            search: 'アイコンを検索...',
            category: 'アイコンカテゴリ',
            description: '投稿ページのサイドリストからアイコンを選択してください',
            selected: '選択されたアイコン',
            no_selected: 'アイコンが選択されていません',
            selected_description: '投稿ページのサイドリストからアイコンを選択してください',
            no_selected_description:
              'アイコンが選択されていません。投稿ページのサイドリストからアイコンを選択してください',
            change_description:
              'サイドリストから別のアイコンを選択するか、現在のアイコンを削除してください',
          },
          success: {
            created_title: '投稿ページが作成されました',
            created_text: '登録が正常に完了しました！',
          },
          error: {
            created_title: '投稿ページの作成エラー！',
            created_text: 'ページの作成中にエラーが発生しました。もう一度お試しください。',
          },
        },
        edit: {
          page_title: '投稿ページを編集',
          page_subtitle: 'コンテンツ投稿ページのデータを編集します。',
          form: {
            title: '投稿ページタイトル',
            type: '投稿ページタイプ',
            status: 'ステータス',
          },
          icon: {
            icon: 'SVGアイコン',
            lib: 'SVGアイコンライブラリ',
            search: 'アイコンを検索...',
            category: 'アイコンカテゴリ',
            description: '投稿ページのサイドリストからアイコンを選択してください',
            selected: '選択されたアイコン',
            no_selected: 'アイコンが選択されていません',
            selected_description: '投稿ページのサイドリストからアイコンを選択してください',
            no_selected_description:
              'アイコンが選択されていません。投稿ページのサイドリストからアイコンを選択してください',
            change_description:
              'サイドリストから別のアイコンを選択するか、現在のアイコンを削除してください',
          },
          success: {
            created_title: '投稿ページが編集されました',
            created_text: '編集が正常に完了しました！',
          },
          error: {
            created_title: '投稿ページの編集エラー！',
            created_text: 'ページの編集中にエラーが発生しました。もう一度お試しください。',
          },
        },
      },
      // Translations for Booking Hotel Services
      booking_hotel_services: {
        // Index page
        page_title: 'サービス予約',
        page_subtitle: 'サービス予約を管理',
        breadcrumb_services: '予約サービス',
        breadcrumb_booking: '予約サービス',
        create_button: 'サービス予約を作成',

        // Table headers
        table_image: '画像',
        table_title: 'タイトル',
        table_order: '順序',
        table_status: 'ステータス',
        table_actions: 'アクション',

        // Table actions
        action_edit: '編集',
        action_delete: '削除',

        // Status
        status_active: 'アクティブ',
        status_inactive: '非アクティブ',

        // Messages
        delete_success: '予約が削除されました',
        delete_error: '予約の削除エラー',
        delete_confirm: '削除を確認しますか？',

        // Create page
        create_title: 'サービス予約を作成',
        create_subtitle: '新しいサービス予約を作成するための情報を入力してください',

        // Edit page
        edit_title: 'ホテル予約を編集',
        edit_subtitle: '予約情報を編集',

        // Form fields
        field_title_label: 'タイトル',
        field_title_placeholder: '例：スパ予約',
        field_status_label: 'ステータス',
        field_description_label: '説明',
        field_image_label: '画像',
        field_icon_label: 'アイコン',

        // Icon picker
        icon_choose: 'アイコンを選択',
        icon_choose_modal: 'アイコンを選択',

        // Day configuration
        day_config_title: '曜日設定',
        day_configure: '設定',
        day_periods_title: '時間帯',
        day_period_add: '期間を追加',
        day_period_max: '最大3期間',
        day_period_none: '期間が設定されていません。少なくとも1つの期間を追加してください。',
        day_period_overlap: '時間帯が重複することはできません。設定した時間を調整してください。',
        day_period_label: '期間',
        day_period_remove: '削除',
        day_interval_label: '間隔（分）',
        day_start_time_label: '開始時間',
        day_end_time_label: '終了時間',

        // Day names
        day_sunday: '日曜日',
        day_monday: '月曜日',
        day_tuesday: '火曜日',
        day_wednesday: '水曜日',
        day_thursday: '木曜日',
        day_friday: '金曜日',
        day_saturday: '土曜日',

        // Grid selection
        grid_title: 'リンクされたグリッド',
        grid_select: 'グリッドを選択',
        grid_selected: 'グリッドが選択されました',
        grid_capacity: '容量',
        grid_multiple: '複数',
        grid_multiple_yes: 'はい',
        grid_multiple_no: 'いいえ',
        grid_status_active: 'アクティブ',
        grid_status_inactive: '非アクティブ',

        // Action buttons
        button_back: '戻る',
        button_save: '保存',
        button_update: '更新',
        button_create: '作成',
        button_cancel: 'キャンセル',
        button_confirm: '確認',

        // Validation messages
        validation_title_required: '必須フィールド',
        validation_title_text: 'タイトルは必須です。',
        validation_icon_required: '必須フィールド',
        validation_icon_text: 'アイコンを選択してください。',
        validation_day_required: '設定が必要',
        validation_day_text: '少なくとも1つの曜日を設定してください。',

        // Success messages
        success_created: '予約が作成されました',
        success_created_text: '予約が正常に作成されました！',
        success_updated: '予約が更新されました',
        success_updated_text: '予約が正常に更新されました！',

        // Error messages
        error_create: '作成エラー',
        error_create_text: '予約の作成中にエラーが発生しました。',
        error_update: '更新エラー',
        error_update_text: '予約の更新中にエラーが発生しました。',
        error_save: 'エラー',
        error_save_text: '予約の保存中にエラーが発生しました。',
        error_load: 'エラー',
        error_load_text: '予約データの読み込みエラー。',

        // Breadcrumbs
        breadcrumb_dashboard: 'ダッシュボード',
        breadcrumb_hospitality: 'ホスピタリティ',
        breadcrumb_hotel_reservations: 'ホテル予約',
        breadcrumb_create: '作成',
        breadcrumb_edit: '編集',
      },
      users: {
        houserkeeping: 'ハウスキーピング',
        maintenancetechnician: 'メンテナンステクニシャン',
        receptionist: 'レセプショニスト',
        manager: 'マネージャー',
        administrator: '管理者',
        waiter: 'ウェイター',
        kitchenchief: 'キッチンチーフ',
        warehouse: '倉庫管理者',
        concierge: 'コンシェルジュ',
        messenger: 'メッセンジャー',
        receptionsupervisor: 'フロントスーパーバイザー',
        telephonist: '電話交換手',
        cook: '料理人',
        barman: 'バーテンダー',
        roomserviceattendant: 'ルームサービス担当',
        steward: 'スチュワード',
        sommelier: 'ソムリエ',
        plumber: '配管工',
        airconditiontechnician: 'エアコン技術者',
        maintenancesupervisor: 'メンテナンススーパーバイザー',
        reservationagent: '予約担当者',
        reservationcoordinator: '予約コーディネーター',
        salesexecutive: '営業責任者',
        revenuemanager: 'レベニューマネージャー',
        commercialmanager: '商業マネージャー',
        administrativeassistant: '管理アシスタント',
        financeaccountspayable: '財務 - 買掛金',
        accountant: '会計士',
        humanresources: '人事',
        purchasingwarehouse: '購買・倉庫',
        recreator: 'レクリエーター',
        activityinstructor: 'アクティビティインストラクター',
        experiencecoordinator: 'エクスペリエンスコーディネーター',
        tourguide: 'ツアーガイド',
        childmonitor: 'チャイルドモニター',
        securityguard: '警備員',
        doorman: 'ドアマン',
        accesscontroller: 'アクセスコントローラー',
        securitysupervisor: 'セキュリティスーパーバイザー',
        generalmanager: 'ゼネラルマネージャー',
        assistantmanager: 'アシスタントマネージャー',
        operationalmanager: 'オペレーショナルマネージャー',
        departmentsupervisorscoordinators: '部門スーパーバイザー・コーディネーター',
        floormanager: 'フロアマネージャー',
        governancesupervisor: 'ハウスキーピングスーパーバイザー',
        generalservicesassistant: '一般サービスアシスタント',
        laundryattendant: 'ランドリー担当',
        laundrymanager: 'リネンマネージャー',
        machinist: '機械オペレーター',
        ironer: 'アイロン担当',
        electrician: '電気技術者',
        carpenter: '大工',
      },
    },
  },
}

export {messages}
// hospitality_experiences block moved inside translations below
